var AnkaReport = (function (exports) {
    'use strict';

    class EventEmitter {
        constructor() {
            this.callbacks = [];
        }
        add(callback) {
            this.callbacks.push(callback);
        }
        remove(callback) {
            const callbackIndex = this.callbacks.findIndex((x) => x === callback);
            if (callbackIndex >= 0) {
                this.callbacks.splice(callbackIndex, 1);
            }
            else {
                console.warn(new Error(`Callback not found. Callback count: ${this.callbacks.length}.`));
            }
        }
        emit(args) {
            this.callbacks.forEach((f) => f(args));
        }
    }

    class Textbox {
        constructor() {
            this.element = document.createElement("input");
        }
        get value() {
            return this.element.value;
        }
        set value(value) {
            this.element.value = value;
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.element.addEventListener("change", () => {
                        listener({ value: this.value });
                    });
                    break;
            }
        }
    }

    class FilePicker {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("input");
            this.element.setAttribute("type", "file");
            this.element.setAttribute("accept", ".png,.jpg,.jpeg");
            this._value = "";
            this._init();
        }
        get value() {
            return this._value;
        }
        set value(value) {
            this._value = value;
            this.refresh();
        }
        _init() {
            this.refresh();
        }
        refresh() {
            //this.element.innerHTML = "";
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.element.addEventListener("change", async () => {
                        const convertBase64 = (file) => {
                            return new Promise((resolve, reject) => {
                                const fileReader = new FileReader();
                                fileReader.readAsDataURL(file);

                                fileReader.onload = () => {
                                    resolve(fileReader.result);
                                };

                                fileReader.onerror = (error) => {
                                    reject(error);
                                };
                            });
                        };
                        const file = this.element.files[0];
                        const base64 = await convertBase64(file);

                        listener({ value: base64 });
                    });
                    break;
            }
        }
    }

    class PropertyGridRow {
        constructor(property, value) {
            this.property = property;
            this.value = value;
            this.element = document.createElement("div");
            this.elementLabel = document.createElement("div");
            this.elementEditorContainer = document.createElement("div");
            this._changeEventEmitter = new EventEmitter();
            if (!!property.editor) {
                this.editor = property.editor;
            } else {
                if (property.type == "image") {
                    this.editor = new FilePicker();
                } else {
                    this.editor = new Textbox();
                }
            }
            //this.editor = property.editor || new Textbox();
            this._init();
        }
        _init() {
            this.element.classList.add("anka-property-grid-row");
            this.elementLabel.classList.add("anka-property-grid-row__label");
            this.elementEditorContainer.classList.add("anka-property-grid-row__editor-container");
            this.element.appendChild(this.elementLabel);
            this.element.appendChild(this.elementEditorContainer);
            this.elementEditorContainer.appendChild(this.editor.element);
            this.editor.addEventListener("change", (e) => {
                this._changeEventEmitter.emit({ value: e.value });
            });
            this.refresh();
        }
        refresh() {
            this.elementLabel.innerText = this.property.label;
            // TODO: I think this is wrong. But working.
            this.editor.value = this.value;
        }
        addEventListener(event, callback) {
            switch (event) {
                case "change":
                    this._changeEventEmitter.add(callback);
                    break;
            }
        }
    }

    class PropertyGrid {
        constructor(options) {
            this._options = options;
            this.element = document.createElement("div");
            this._properties = [];
            this._dataSource = null;
            this._init();
        }
        get properties() {
            return this._properties;
        }
        set properties(value) {
            this._properties = value;
            this.refresh();
        }
        get dataSource() {
            return this._dataSource;
        }
        set dataSource(value) {
            if (this._dataSource) {
                this._dataSource.removeEventListener("change", this.refresh);
            }
            this._dataSource = value;
            this.refresh();
            if (this._dataSource) {
                this._dataSource.addEventListener("change", this.refresh);
            }
        }
        _init() {
            this.element.classList.add("anka-property-grid");
            this.refresh = this.refresh.bind(this);
            this.onChange = this.onChange.bind(this);
            this.refresh();
        }
        refresh() {
            var _a;
            this.element.innerHTML = "";
            if (!this._dataSource || this._properties.length === 0) {
                this.element.innerText = "No property!";
                this.element.style.padding = "3px";
            }
            else {
                this.element.style.padding = "";
            }
            if (!this._dataSource)
                return;

            for (let i = 0; i < this._properties.length; i++) {
                const property = this._properties[i];
                let value = "";
                if (property['IS_EXTRA_PROPERTY'] !== undefined && property['IS_EXTRA_PROPERTY'] === true && !!property['value']) {
                    value = property['value'];
                } else {
                    value = (_a = this._dataSource[property.field]) !== null && _a !== void 0 ? _a : "";
                }
                const row = new PropertyGridRow(property, value.toString());
                row.addEventListener("change", (e) => {
                    this.onChange(property, e);
                });
                this.element.appendChild(row.element);
            }
        }
        onChange(property, args) {
            if (this._dataSource == null)
                return;
            switch (property.type) {
                case "object":
                    this._dataSource[property.field] = args.value;
                    break;
                case "string":
                case "image":
                case "select":
                    this._dataSource[property.field] = args.value;
                    if (!!this._dataSource.extraProperties && property['IS_EXTRA_PROPERTY'] !== undefined && property['IS_EXTRA_PROPERTY'] === true && !!property['field']) {
                        const extraProperties = this._dataSource.extraProperties;
                        const extraPropertyIndex = extraProperties.findIndex(p => p.field == property.field);
                        extraProperties[extraPropertyIndex].value = args.value;
                        this._dataSource.extraProperties = extraProperties;
                    }
                    break;
                case "number":
                    const intValue = parseInt(args.value);
                    if (!isNaN(intValue)) {
                        this._dataSource[property.field] = intValue;
                        if (!!this._dataSource.extraProperties && property['IS_EXTRA_PROPERTY'] !== undefined && property['IS_EXTRA_PROPERTY'] === true && !!property['field']) {
                            const extraProperties = this._dataSource.extraProperties;
                            const extraPropertyIndex = extraProperties.findIndex(p => p.field == property.field);
                            extraProperties[extraPropertyIndex].value = args.value;
                            this._dataSource.extraProperties = extraProperties;
                        }
                    }
            }
        }
        setDataSource(properties, hiddenProperties) {
            if (properties) {
                let propertyDefinitions = properties.getPropertyDefinitions({ fields: this._options.fields });
                if (!!hiddenProperties) {
                    propertyDefinitions = propertyDefinitions.filter(pd => hiddenProperties.lastIndexOf(pd.field) == -1);
                }
                this.properties = propertyDefinitions;
                this.dataSource = properties;
            }
            else {
                this.properties = [];
                this.dataSource = null;
            }
        }
    }

    var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAbwAAAG8B8aLcQwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFzSURBVDiNjdNPS9RRFMbxzzEJIf+EaBgkLmKSNkKRoBuJoLIC27RqNYvehtAr8CX4ChQiCCIIxIVECEELI6pdUJuJgooimONi7sVRZmIOPIvfvfd37nO+95zITBExjiW8xUMEhorCUZzCMD5jOzO/wzweYyYzDSJcwAbmh7CMWdyMiLmIGNEnImIkIuZwHaNYDjTxHBPFzXmc6SoB2kW/8AXv8QOrw10XfEQLrSw+ezhYxG28xJgCpMYY7mEqIiq8KtjBJUxjEv+UzWbh8ASvM7PVj0FxMY1ruI9XNcELXMTlkj1wsoy69g3v8Am3aglt7OHgfw4i4ipWsa8D/RiDCTyIiMnyfdLBTnF4ruhv3WhiCzcQAzTR6XJ2C83KYBdX0HBEvReDuv4Bb7BSS/idmdsREf16oDBYwF08w9ljDMrzPIqISrsm2sQdne5bwBRm8Kf+28A6ZgccpHGd2VlHI8o4j2KtZO7VhdmlNr7iaWb+PAQ5CK7LXYnUvgAAAABJRU5ErkJggg==";

    var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADSSURBVDiNzdO9SkNBEAXg78b0ksLK0pAutY0EsbOTFBZ5BB8gaVPqO9inFYsgVgbS2FrnBdLamBBEi3sXluWuGkmRAwM7h9kzP8wUaGCAY3/DC16DEz4P0YrsNvEDd4RHnMeK48pifNVkDtwZlrgIFWyLOa4xwWkzE7TGKOFW0XuGe1zmBPro1XAxNpATmFb2K/4zg90KpC20cYWDTPwnHrDICTzhGe8ZgUPlbDo5gRPc/FSyZMn2Y4gL5TF9VFy6gXUYKRfrrkChvMjulsnfMPkGlb0hK3Zvlo0AAAAASUVORK5CYII=";

    var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACTSURBVDiNzdCxDcIwFIThzyhMQsEAIKpIiKlC6TYjMEdKqBB0DMAY1GmgIIqCFCTHouAa657se+c/4ISbPK0LXBCxxfzLxTsClp1vcUacZW7uFdB0LXJUDk3MSShGZhvsEt+3Q3NE1Z2pisMGV9TeXKrEgNVH2oTNvf6TwUM6g8XYFw4TGvyWQSODQRgZ7vFMDChfZ94cBBBG80sAAAAASUVORK5CYII=";

    var icon_image_placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaklEQVR4nO3Yv0scQRTA8U9ia8pAwFJMKQipzZZeIVgLFwhWsTB/RppUQvoUHopXCrbXaRPshATyB2iVCKJCTlcOTljOvdM979fG94VX7sz78mbezgxBEARB8J/yAb9wg3RMcYOfqBZNvjLGpNMusVREYHsCEk47olZEoJH58JPxsZ7Jo5VTXwKJ8ZGEgN4VuOtUf1DHmzJVoJKz0Q7wQkkEtrt0i7dKIlDrIjBncCSxhPTexNX2r761iXfLtolHQRICogL3eI1vOMYRvmBaSZbQO5zmtN7fmJ10gfc463FcPsHCqATm8R2H2MHiA+Ot4PIRZ/6/HWMNReAz/uVc/b7iZc5YH9EscHG5wPIwBKaw+cDk+3iVGWcD133cvppYG6RAq0vsPXLyH5hpd5eiiacdVa0PQmC13e6KTH7+xOTTnOhb4GoIyYxUIJ2QaISAElWgNgFLJu2IrWf1tJi9bZXycTcIgiAIlIFbufOCQD+tqawAAAAASUVORK5CYII";
    var icon_barcode_placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAbklEQVR4nO3XOwqAMBRFwbP/TWuhAfELljoDKWIRCPEl9xUAcDCtYz+/+nY23qx1tfbwND+wkZxIfq3UyMKtles378jgZU9ESdbaEhoTGhMau6FGUiOpkdTIQmOVxiqN1aCxSmOVxuqToREAfmkGsQp8rqTa/uIAAAAASUVORK5CYII=";
    var icon_qrcode_placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAmklEQVR4nO2VYQqAIAyF3/ES73+B7B6LfigR6TZdWuQHQopvT2ObwOSPeAAbALqMAMA9oEuEG3EcK+x1ibiZW+fm3HpxY+6bm5d0WWoDmBqf0RhrdOokuQZsTi6XCXKIl4KxVDdprltpXb/XWMqwA5CVsRe+MuY3DZUNpNmYlK3P7ACkbPbdjWnUr6ZRyWVet075ynTvWJNvsAP0++PmKZoIpgAAAABJRU5ErkJggg==";
    var icon_table_placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAU0lEQVR4nGNgGG7Ag4GB4TEDA8N/MvEjqBk4wSMKDP+PZAlOAFNEK3mGUQv+E2sBpXjgLRj6cTD0Lfg/mopwgVEL/hOygOYVjgeFljwiVGUOPQAANzTTZqbEZ1wAAAAASUVORK5CYII=";

    const Database = img$2;
    const Save = img$1;
    const TreeStructure = img;

    class TreeItem {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.elementHeader = document.createElement("div");
            this.elementIcon = document.createElement("div");
            this.elementLabel = document.createElement("div");
            this.elementChildren = document.createElement("div");
            this._collapsed = options.collapsed !== undefined ? options.collapsed : true;
            this._init();
        }
        get collapsed() {
            return this._collapsed;
        }
        set collapsed(value) {
            this._collapsed = value;
            this.refresh();
        }
        _init() {
            this.element.classList.add("anka-tree-item");
            this.elementHeader.classList.add("header");
            this.elementIcon.classList.add("icon");
            if (this.options.collapseByArrow) {
                this.elementIcon.classList.add("hover");
            }
            this.elementLabel.classList.add("label");
            this.elementChildren.classList.add("children");
            this.element.appendChild(this.elementHeader);
            this.elementHeader.appendChild(this.elementIcon);
            this.elementHeader.appendChild(this.elementLabel);
            if (this.options.renderer) {
                this.options.renderer(this, this.options.data);
            }
            if (this.hasChild) {
                this.element.appendChild(this.elementChildren);
                this.options.data.children.forEach((x) => {
                    const item = new TreeItem({
                        data: x,
                        renderer: this.options.renderer,
                    });
                    this.elementChildren.appendChild(item.element);
                });
                this.elementIcon.addEventListener("click", () => {
                    this.collapsed = !this.collapsed;
                });
                if (!this.options.collapseByArrow) {
                    this.elementLabel.addEventListener("click", () => {
                        this.collapsed = !this.collapsed;
                    });
                }
            }
            this.refresh();
        }
        refresh() {
            this.elementLabel.innerText = this.options.data.label;
            if (this.hasChild) {
                if (this.collapsed) {
                    this.elementIcon.innerText = "→";
                }
                else {
                    this.elementIcon.innerText = "↓";
                }
            }
            else {
                this.elementIcon.innerText = "";
            }
            this.elementChildren.style.display = this.collapsed ? "none" : "block";
        }
        addEventListener(event, listener) {
            if (event === "click") {
                this.elementLabel.addEventListener("click", () => listener(undefined));
            }
        }
        get hasChild() {
            return this.options.data.children && this.options.data.children.length > 0;
        }
    }

    class TreeList {
        constructor(options) {
            this.element = document.createElement("div");
            this.dataSource = (options === null || options === void 0 ? void 0 : options.dataSource) || [];
            this.itemRenderer = options === null || options === void 0 ? void 0 : options.itemRenderer;
            this.collapseByArrow = options === null || options === void 0 ? void 0 : options.collapseByArrow;
            this._collapsedByDefault = options.collapsedByDefault !== undefined ? options.collapsedByDefault : true;
            this.init();
        }
        init() {
            this.element.classList.add("anka-tree-list");
            this.refresh();
        }
        get collapsedByDefault() {
            return this._collapsedByDefault;
        }
        set collapsedByDefault(value) {
            this._collapsedByDefault = value;
            this.refresh();
        }
        refresh() {
            this.element.innerHTML = "";
            this.dataSource.forEach((data) => {
                const item = new TreeItem({
                    data,
                    renderer: this.itemRenderer,
                    collapseByArrow: this.collapseByArrow,
                    collapsed: this.collapsedByDefault
                });
                this.element.appendChild(item.element);
            });
        }
    }

    class DataSourceTreeList extends TreeList {
        constructor(options) {
            const dataSource = (options === null || options === void 0 ? void 0 : options.dataSource)
                ? convertToDataSource(options.dataSource)
                : undefined;
            super({
                dataSource,
                itemRenderer: dataSourceItemRenderer,
            });
        }
        setDataSource(dataSource) {
            this.dataSource = convertToDataSource(dataSource);
            this.refresh();
        }
    }
    const convertToDataSource = (data) => {
        return data.map((x) => ({
            label: x.label,
            data: x,
            children: x.children ? convertToDataSource(x.children) : undefined,
            extraProperties: x.extraProperties,
            type: x.type
        }));
    };
    const dataSourceItemRenderer = (item, itemData) => {
        if (item.hasChild)
            return;
        item.element.draggable = true;
        item.element.addEventListener("dragstart", (e) => {
            var _a, _b;
            (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData("label", itemData.label);
            (_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.setData("field", itemData.data.field);
            (_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.setData("value", itemData.data.value);
            (_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.setData("extraProperties", JSON.stringify(itemData.data.extraProperties));
            (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData("type", itemData.type);
        });

        item.element.addEventListener("dblclick", (e) => {
            if (!navigator.clipboard) {
                console.error('Accès au presse-papier impossible : Vérifier que le navigateur a les droits nécéssaires');
                return;
            }
            navigator.clipboard.writeText(`@[${itemData.data.field}]`);
        });
    };

    class ElementsTreeList extends TreeList {
        constructor(options) {
            super({
                collapseByArrow: true,
                itemRenderer: (treeItem, data) => this._itemRenderer(treeItem, data),
            });
            this.options = options;
        }
        refresh() {
            if (!this.options)
                return;
            this.dataSource = this.getDataSource();
            super.refresh();
        }
        _itemRenderer(treeItem, treeItemData) {
            switch (treeItemData.data.type) {
                case "section":
                    treeItem.addEventListener("click", () => {
                        treeItemData.data.component.element.focus();
                    });
                    break;
                case "item":
                    treeItem.addEventListener("click", () => {
                        treeItemData.data.component.element.focus();
                    });
                    break;
            }
        }
        getDataSource() {
            const datasources = [];
            const s1 = this.options.reportContainer.report.reportSectionHeader;
            if (!!s1) { datasources.push(this.getSectionData(s1, "Header")); }
            const s2 = this.options.reportContainer.report.reportSectionContent;
            if (!!s2) { datasources.push(this.getSectionData(s2, "Content")); }
            const s3 = this.options.reportContainer.report.reportSectionFooter;
            if (!!s3) { datasources.push(this.getSectionData(s3, "Footer")); }
            return datasources;
        }
        getSectionData(section, label) {
            return {
                label: label || `Section [${section.properties.binding}]`,
                data: {
                    type: "section",
                    component: section,
                },
                children: [
                    ...section.items.map((x) => {
                        const item = {
                            label: `Text [${x.properties.binding || x.properties.text || ""}]`,
                            data: {
                                type: "item",
                                component: x,
                            },
                        };
                        return item;
                    }),
                    ...section.subsections.map((x) => this.getSectionData(x)),
                ],
            };
        }
    }

    class Point {
        constructor(x, y, onchange) {
            this.onchange = onchange;
            this._x = 0;
            this._y = 0;
            if (x)
                this._x = x;
            if (y)
                this._y = y;
        }
        get x() {
            return this._x;
        }
        set x(value) {
            this._x = value;
            if (this.onchange)
                this.onchange();
        }
        get y() {
            return this._y;
        }
        set y(value) {
            this._y = value;
            if (this.onchange)
                this.onchange();
        }
    }

    class DragDrop {
        constructor(options) {
            this.options = options;
            this.originalLocation = new Point();
            this.newLocation = new Point();
            this.offset = new Point();
            this.onMouseDown = this.onMouseDown.bind(this);
            this.onMouseMove = this.onMouseMove.bind(this);
            this.onMouseUp = this.onMouseUp.bind(this);
            this.options.element.addEventListener("mousedown", this.onMouseDown);
        }
        onMouseDown(e) {
            if (e.target !== this.options.element)
                return;
            this.originalLocation.x = e.x;
            this.originalLocation.y = e.y;
            this.newLocation.x = this.originalLocation.x;
            this.newLocation.y = this.originalLocation.y;
            this.offset.x = e.x;
            this.offset.y = e.y;
            this.onMouseMove(e);
            this.options.container.addEventListener("mousemove", this.onMouseMove);
            document.addEventListener("mouseup", this.onMouseUp, {
                once: true,
            });
        }
        onMouseMove(e) {
            this.newLocation.x = e.x;
            this.newLocation.y = e.y;
            this.offset.x = this.newLocation.x - this.originalLocation.x;
            this.offset.y = this.newLocation.y - this.originalLocation.y;
            const args = {
                originalX: this.originalLocation.x,
                originalY: this.originalLocation.y,
                newX: this.newLocation.x,
                newY: this.newLocation.y,
                offsetX: this.offset.x,
                offsetY: this.offset.y,
            };
            this.options.onMouseMove(args);
        }
        onMouseUp() {
            this.options.container.removeEventListener("mousemove", this.onMouseMove);
            const args = {
                originalX: this.originalLocation.x,
                originalY: this.originalLocation.y,
                newX: this.newLocation.x,
                newY: this.newLocation.y,
                offsetX: this.offset.x,
                offsetY: this.offset.y,
            };
            this.options.onMouseUp(args);
        }
    }

    var ResizerOrientation;
    (function (ResizerOrientation) {
        ResizerOrientation[ResizerOrientation["Horizontal"] = 0] = "Horizontal";
        ResizerOrientation[ResizerOrientation["Vertical"] = 1] = "Vertical";
    })(ResizerOrientation || (ResizerOrientation = {}));
    class Resizer {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.offset = new Point();
            this.init();
        }
        init() {
            this.element.classList.add("anka-resizer");
            switch (this.options.orientation) {
                case ResizerOrientation.Vertical:
                    this.element.classList.add("vertical");
                    break;
                case ResizerOrientation.Horizontal:
                    this.element.classList.add("horizontal");
                    break;
            }
            //if (this.options.orientation != ResizerOrientation.Vertical) {
            new DragDrop({
                element: this.element,
                container: document,
                onMouseMove: (e) => this.onMouseMove(e),
                onMouseUp: (e) => this.onMouseUp(e),
            });
            //}
        }
        refresh() {
            switch (this.options.orientation) {
                case ResizerOrientation.Vertical:
                    this.element.style.right = -this.offset.x + "px";
                    break;
                case ResizerOrientation.Horizontal:
                    this.element.style.bottom = -this.offset.y + "px";
                    break;
            }
        }
        clear() {
            switch (this.options.orientation) {
                case ResizerOrientation.Vertical:
                    this.element.style.right = "";
                    break;
                case ResizerOrientation.Horizontal:
                    this.element.style.bottom = "";
                    break;
            }
        }
        onMouseMove(e) {
            this.offset.x = e.offsetX;
            this.offset.y = e.offsetY;
            this.refresh();
        }
        onMouseUp(e) {
            this.clear();
            if (this.options.onResize) {
                this.options.onResize(e);
            }
        }
    }

    class Menu {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this._clickEventEmitter = new EventEmitter();
            this.init();
        }
        init() {
            this.element.classList.add("anka-menu");
            if (this.options.onClick) {
                this.addEventListener("click", this.options.onClick);
            }
            this.refresh();
        }
        refresh() {
            this.element.innerHTML = "";
            this.element.style.width = this.options.width || "";
            this.element.style.height = this.options.height || "";
            this.options.buttons
                .filter((x) => x)
                .forEach((button) => {
                    const elementButton = document.createElement("div");
                    elementButton.classList.add("anka-menu-button");
                    elementButton.innerText = button.label;
                    elementButton.addEventListener("click", () => {
                        this.emitOnClick(button.key, button.data);
                    });
                    this.element.appendChild(elementButton);
                });
        }
        addEventListener(event, listener) {
            switch (event) {
                case "click":
                    this._clickEventEmitter.add(listener);
                    break;
            }
        }
        emitOnClick(key, data) {
            this._clickEventEmitter.emit({ key, data });
        }
    }

    class ContextMenu {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.menu = new Menu(options);
            this.init();
        }
        init() {
            this.element.classList.add("anka-context-menu-container");
            document.body.appendChild(this.element);
            this.element.appendChild(this.menu.element);
            this.element.addEventListener("click", (e) => {
                if (e.target === this.element) {
                    this.dispose();
                }
            });
            this.menu.addEventListener("click", () => this.dispose());
            this.refresh();
        }
        refresh() {
            this.menu.refresh();
            this.menu.element.style.left = `${this.options.left}px`;
            this.menu.element.style.top = `${this.options.top}px`;
        }
        dispose() {
            this.element.remove();
        }
    }

    function isValidStyle(value) {
        return !(value === undefined || value === null || value === "");
    }
    class MultipleStyles {
        constructor(...styles) {
            this.styles = [];
            this.styles.push(...styles);
        }
        join(styles) {
            this.styles.push(styles);
        }
        getList() {
            return this.styles;
        }
        getStyle(property, defaultValue) {
            for (let i = this.styles.length - 1; i >= 0; i--) {
                const styles = this.styles[i];
                if (isValidStyle(styles[property])) {
                    return styles[property];
                }
            }
            return defaultValue;
        }
    }

    class ColorPicker {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("input");
            this.element.type = "color";
        }
        get value() {
            if (this.element.value === this.options.defaultValue) {
                return "";
            }
            return this.element.value;
        }
        set value(value) {
            if (!value) {
                this.element.value = this.options.defaultValue;
            }
            else {
                this.element.value = value;
            }
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.element.addEventListener("change", () => {
                        listener({ value: this.value });
                    });
                    break;
            }
        }
    }

    class DropdownList {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("select");
            this.items = [];
            this._value = "";
            this._init();
        }
        get value() {
            return this._value;
        }
        set value(value) {
            this._value = value;
            this.refresh();
        }
        _init() {
            this._value = this.options.defaultValue;
            this.refresh();
        }
        refresh() {
            this.element.innerHTML = "";
            this.items.length = 0;
            for (let i = 0; i < this.options.items.length; i++) {
                const item = this.options.items[i];
                const option = document.createElement("option");
                option.innerText = item.label;
                option.value = item.value;
                if (this._value == item.value) {
                    option.selected = true;
                }
                this.element.appendChild(option);
                this.items.push(option);
            }
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.element.addEventListener("change", () => {
                        listener({ value: this.element.value });
                    });
                    break;
            }
        }
    }

    class ExpressionEditor {
        constructor(options, expressionValue) {
            this._options = options;
            this.element = document.createElement("div");
            this.element.className = "input-wrapper";
            this._value = expressionValue ?? {};
            this._expression = expressionValue ?? {};
            this._isModalOpened = false;
            this._changeEventEmitter = new EventEmitter();
            this._init();

        }
        get value() {
            return this._value;
        }
        set value(value) {
            this._value = value;
            this.refresh();
        }
        get expression() {
            return this._expression;
        }
        set expression(expression) {
            this._expression = expression;
            this.refresh();
        }
        _init() {
            //this._value = this.options.defaultValue;
            this.refresh();
        }
        refresh() {
            this.element.innerHTML = "";

            const input = document.createElement("input");
            input.type = "text";
            input.value = `${this.countElements(this.expression).conditions} condition(s)`;
            input.readOnly = true;

            const iconBtn = document.createElement("button");
            iconBtn.className = "icon-btn";
            iconBtn.innerHTML = "🔍";
            iconBtn.addEventListener("click", () => {
                if (!this._isModalOpened) {
                    this.createModal();
                    this._isModalOpened = true;
                }
            });

            this.element.appendChild(input);
            this.element.appendChild(iconBtn);
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this._changeEventEmitter.add(() => {
                        listener({ value: this.expression });
                    });
                    break;
            }
        }

        createModal() {
            // modal
            const overlay = document.createElement("div");
            overlay.className = "modal-overlay";

            const box = document.createElement("div");
            box.className = "modal-box";

            const titleEl = document.createElement("h3");
            titleEl.className = "modal-expression-title";
            titleEl.innerText = "Conditions de visibilité";
            titleEl.style.margin = "0px 10px";


            // container for ConditionBuilder
            const builderContainer = document.createElement("div");
            builderContainer.style.overflowY = "auto";
            builderContainer.style.padding = "10px";

            const buttonContainer = document.createElement("div");
            buttonContainer.className = "flex flex-row justify-end";

            // buttons
            const saveBtn = document.createElement("button");
            saveBtn.className = "btn";
            saveBtn.textContent = "Valider";

            const cancelBtn = document.createElement("button");
            cancelBtn.className = "btn danger";
            cancelBtn.textContent = "Annuler";
            cancelBtn.style.marginLeft = "10px";

            buttonContainer.appendChild(saveBtn);
            buttonContainer.appendChild(cancelBtn);

            // Assemble modal
            box.appendChild(titleEl);
            box.appendChild(builderContainer);
            box.appendChild(buttonContainer);
            overlay.appendChild(box);
            document.body.appendChild(overlay);

            requestAnimationFrame(() => overlay.classList.add("show"));

            // INIT Condition Builder
            const fieldsOptions = []
            if (!!this._options?.fields) {
                this._options.fields.filter(f => !!f.children).forEach(field => {
                    fieldsOptions.push({ label: field.label, children: field.children.map(c => ({ value: c.field, label: c.label })) });
                });
            }
            const builder = new ConditionBuilder(builderContainer, fieldsOptions);
            builder.loadFromValue(this.expression);

            // Save
            saveBtn.onclick = () => {
                const result = builder.getJSON();
                this.expression = result;
                this._changeEventEmitter.emit("change", result);
                overlay.remove();
                this._isModalOpened = false;
                this.refresh();
            };

            // Cancel
            cancelBtn.onclick = () => {
                overlay.remove();
                this._isModalOpened = false;
            }

            // Click outside
            overlay.onclick = (e) => {
                if (e.target === overlay) {
                    overlay.remove();
                    this._isModalOpened = false;
                }
            };
        }

        countElements(query) {
            let conditionCount = 0;
            let groupCount = 0;

            function explore(node) {
                if (!node) return;
                if (node.type === "condition") {
                    conditionCount++;
                    return;
                }

                if (node.type === "group" && Array.isArray(node.conditions)) {
                    groupCount++;
                    node.conditions.forEach(subNode => explore(subNode));
                }
            }

            explore(query);

            return {
                conditions: conditionCount,
                groups: groupCount,
                total: conditionCount + groupCount
            };
        }
    }

    class ConditionBuilder {
        constructor(container, fields = []) {
            this.container = container;
            this.fields = this.normalizeFields(fields); // liste uniformisée
            this.operators = [
                { label: "Egal à (=)", value: "=" },
                { label: "Est supérieur à (>)", value: ">" },
                { label: "Est supérieur ou égal à (>=)", value: ">=" },
                { label: "Est inférieur à (<)", value: "<" },
                { label: "Est inférieur ou égal à (<=)", value: "<=" },
                { label: "Est différent de (!=)", value: "!=" },
                { label: "Est vide", value: "empty" },
                { label: "N'est pas vide", value: "not_empty" },
            ];
            this.rootGroup = this.createGroup(true);
            container.appendChild(this.rootGroup.element);
        }

        loadFromValue(value, parentGroup) {
            if (!value) return;
            const firstIteration = !parentGroup;
            if (firstIteration) { parentGroup = this.rootGroup; }

            // Si c'est un groupe
            if (value.type === "group" && value.conditions.length > 0) {
                let currentGroup = parentGroup;
                if (!firstIteration && parentGroup.id !== value.id) {
                    currentGroup = this.createGroup();
                    parentGroup.conditions.push(currentGroup);
                    parentGroup.element.appendChild(currentGroup.element);
                }

                // mettre à jour l'opérateur
                currentGroup.operator = value.operator;
                const opSelect = currentGroup.element.querySelector("select");
                if (opSelect) opSelect.value = value.operator;

                // parcourir les éléments du groupe
                if (Array.isArray(value.conditions)) {
                    value.conditions.forEach(item => this.loadFromValue(item, currentGroup));
                }
            }

            // Si c'est une condition
            if (value.type === "condition") {
                const cond = this.createCondition(parentGroup);
                cond.field = value.field;
                cond.operator = value.operator;
                cond.compareType = value.compareType;
                cond.value = value.value;

                // mettre à jour le DOM
                const selects = cond.element.querySelectorAll("select");
                const input = cond.element.querySelector("input");
                let compareTypeSelect = null;
                let otherFieldSelect = null;

                if (selects.length > 0) selects[0].value = value.field;
                if (selects.length > 1) selects[1].value = value.operator;
                if (selects.length > 2) {
                    selects[2].value = value.compareType;
                    compareTypeSelect = selects[2];
                }
                if (selects.length > 3) {
                    otherFieldSelect = selects[3];
                    otherFieldSelect.value = value.value;
                }

                if (value.operator === "empty" || value.operator === "not_empty") {
                    input.style.display = "none";
                    compareTypeSelect.style.display = "none";
                    otherFieldSelect.style.display = "none";
                } else {
                    input.style.display = "inline-block";
                    input.value = value.value;

                    if (value.compareType === "field") {
                        input.style.display = "none";
                        otherFieldSelect.style.display = "inline-block";
                    } else {
                        input.style.display = "inline-block";
                        otherFieldSelect.style.display = "none";
                    }
                }

                

                parentGroup.conditions.push(cond);
                parentGroup.element.appendChild(cond.element);
            }
        }


        normalizeFields(fields) {
            return fields.map(f => {
                if (typeof f === "string") return { label: f, value: f };
                return f;
            });
        }

        createGroup(isRoot) {
            const uuid = function () {
                return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
                );
            };
            const group = {
                id: uuid(),
                type: "group",
                operator: "AND",
                conditions: [],
            };

            const wrapper = document.createElement("div");
            wrapper.className = "group";

            const opSelect = document.createElement("select");
            opSelect.innerHTML = `
      <option value="AND">ET</option>
      <option value="OR">OU</option>
    `;
            opSelect.addEventListener("change", () => group.operator = opSelect.value);
            wrapper.appendChild(opSelect);

            const addCondBtn = document.createElement("button");
            addCondBtn.className = "btn";
            addCondBtn.textContent = "Ajouter condition";
            addCondBtn.onclick = () => {
                const cond = this.createCondition(group);
                group.conditions.push(cond);
                wrapper.appendChild(cond.element);
            };
            wrapper.appendChild(addCondBtn);

            const addGroupBtn = document.createElement("button");
            addGroupBtn.className = "btn";
            addGroupBtn.style.marginLeft = "5px";
            addGroupBtn.textContent = "Ajouter groupe";
            addGroupBtn.onclick = () => {
                const subgroup = this.createGroup();
                group.conditions.push(subgroup);
                wrapper.appendChild(subgroup.element);
            };
            wrapper.appendChild(addGroupBtn);

            if (!isRoot) {
                const delBtn = document.createElement("button");
                delBtn.className = "btn danger";
                delBtn.textContent = "X";
                delBtn.onclick = () => {
                    group.conditions = [];
                    wrapper.remove();
                };
                wrapper.appendChild(delBtn);
            }

            group.element = wrapper;
            return group;
        }

        createCondition(parentGroup) {
            const condition = {
                type: "condition",
                field: "",
                operator: "=",
                compareType: "value", // "value" ou "field"
                value: ""
            };

            const row = document.createElement("div");
            row.className = "condition";

            // --- SELECT FIELD ---
            const fieldSelect = document.createElement("select");
            fieldSelect.style.flex = 1;
            fieldSelect.innerHTML = this.fields
                .map(f =>
                    `<optgroup label="${f.label}">` +
                    f.children.map(c => `<option value="${c.value}">[${f.label}] - ${c.label}</option>`).join("") +
                    `</optgroup>`
                ).join("");

            // valeur par défaut
            if (this.fields.length > 0 && this.fields[0].children.length > 0) {
                condition.field = this.fields[0].children[0].value;
            }

            fieldSelect.value = condition.field;
            fieldSelect.onchange = () => condition.field = fieldSelect.value;
            row.appendChild(fieldSelect);

            // --- OPÉRATEUR ---
            const operatorSelect = document.createElement("select");
            operatorSelect.style.flex = 1;
            this.operators.forEach(o => {
                const opt = document.createElement("option");
                opt.value = o.value;
                opt.textContent = o.label;
                operatorSelect.appendChild(opt);
            });
            operatorSelect.onchange = () => condition.operator = operatorSelect.value;
            row.appendChild(operatorSelect);

            // --- SELECT : TYPE DE COMPARAISON ---
            const compareSelect = document.createElement("select");
            operatorSelect.style.flex = 1;
            compareSelect.innerHTML = `
        <option value="value">Valeur constante</option>
        <option value="field">Autre champ</option>
    `;
            compareSelect.onchange = () => {
                condition.compareType = compareSelect.value;
                updateValueField();
            };
            row.appendChild(compareSelect);

            // --- INPUT VALEUR CONSTANTE ---
            const valueInput = document.createElement("input");
            valueInput.style.flex = 1;
            valueInput.placeholder = "Valeur";
            valueInput.oninput = () => condition.value = valueInput.value;

            // --- SELECT AUTRE CHAMP ---
            const otherFieldSelect = document.createElement("select");
            otherFieldSelect.style.flex = 1;
            otherFieldSelect.innerHTML = this.fields
                .map(f =>
                    `<optgroup label="${f.label}">` +
                    f.children.map(c => `<option value="${c.value}">[${f.label}] - ${c.label}</option>`).join("") +
                    `</optgroup>`
                ).join("");
            otherFieldSelect.onchange = () => condition.value = otherFieldSelect.value;
            otherFieldSelect.style.display = "none"; // masqué par défaut

            row.appendChild(valueInput);
            row.appendChild(otherFieldSelect);

            // Afficher selon compareType
            function updateValueField() {
                if (compareSelect.value === "value") {
                    valueInput.style.display = "inline-block";
                    otherFieldSelect.style.display = "none";
                } else {
                    valueInput.style.display = "none";
                    otherFieldSelect.style.display = "inline-block";
                }
            }

            updateValueField();

            // masquer input si empty / not_empty
            operatorSelect.addEventListener("change", () => {
                if (operatorSelect.value === "empty" || operatorSelect.value === "not_empty") {
                    valueInput.style.display = "none";
                    otherFieldSelect.style.display = "none";
                    compareSelect.style.display = "none";
                } else {
                    compareSelect.style.display = "inline-block";
                    updateValueField();
                }
            });

            // --- DELETE BUTTON ---
            const delBtn = document.createElement("button");
            delBtn.className = "btn danger";
            delBtn.textContent = "X";
            delBtn.onclick = () => {
                parentGroup.conditions = parentGroup.conditions.filter(c => c !== condition);
                row.remove();
            };
            row.appendChild(delBtn);

            condition.element = row;
            return condition;
        }

        getJSON() {
            return this.serializeGroup(this.rootGroup);
        }

        serializeGroup(group) {
            return {
                id: group.id,
                type: "group",
                operator: group.operator,
                conditions: group.conditions.map(c => {
                    if (c.type === "group") return this.serializeGroup(c);
                    return {
                        type: "condition",
                        field: c.field,
                        operator: c.operator,
                        compareType: c.compareType,
                        value: c.value
                    };
                })
            };
        }
    }

    function createLayoutModesDropdownEditor() {
        return new DropdownList({
            defaultValue: 0,
            items: [
                { value: 0, label: "Default layout" },
                { value: 1, label: "Header layout" },
                { value: 2, label: "Footer layout" },
                { value: 3, label: "No layout" },
            ],
        });
    }

    function createTextModeDropdownEditor() {
        return new DropdownList({
            defaultValue: "single",
            items: [
                { value: "single", label: "Single Line" },
                { value: "multi", label: "Multi Line" },
            ],
        });
    }

    function createBorderStyleDropdownEditor() {
        return new DropdownList({
            defaultValue: "none",
            items: [
                { value: "none", label: "none" },
                { value: "dotted", label: "dotted" },
                { value: "dashed", label: "dashed" },
                { value: "solid", label: "solid" },
                /*{ value: "double", label: "double" },
                { value: "groove", label: "groove" },
                { value: "ridge", label: "ridge" },
                { value: "inset", label: "inset" },
                { value: "outset", label: "outset" },*/
            ],
        });
    }

    function createFontFamilyDropdownEditor() {
        return new DropdownList({
            defaultValue: "Arial",
            items: [
                { value: "Arial", label: "Arial" },
                { value: "Helvetica", label: "Helvetica" },
                { value: "Myriad Pro", label: "Myriad Pro" },
                { value: "Delicious", label: "Delicious" },
                { value: "Verdana", label: "Verdana" },
                { value: "Georgia", label: "Georgia" },
                { value: "Courier", label: "Courier" },
                { value: "Comic Sans MS", label: "Comic Sans MS" },
                { value: "Impact", label: "Impact" },
                { value: "Monaco", label: "Monaco" },
                { value: "Optima", label: "Optima" },
                { value: "Hoefler Text", label: "Hoefler Text" },
                { value: "Plaster", label: "Plaster" },
                { value: "Engagement", label: "Engagement" },
            ],
        });
    }

    function createTypeSectionDropdownEditor(opts) {
        let options = opts.typesSections ?? [];
        return new DropdownList({
            defaultValue: "",
            items: options,
        });
    }

    /*
function createTypeSectionDropdownEditor(typeReport) {
    let options = [
        { value: "", label: "Aucun" },
        { value: "LIGNES", label: "Lignes" },
        { value: "REGLEMENTS", label: "Règlements" },
        { value: "TAXES", label: "Taxes" },
    ];
    if (typeReport == 1 || typeReport == 8) { // RECU && DUPLICATA
        options = [
            { value: "", label: "Aucun" },
            { value: "LIGNES", label: "Lignes" },
            { value: "LIGNE_EXTRAS", label: "Ligne (Complément)" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "REGLEMENT_EXTRAS", label: "Règlement (Complément)" },
            { value: "TAXES", label: "Taxes" },
        ];
    } else if (typeReport == 2) { // X CAISSE
        options = [
            { value: "", label: "Aucun" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "TAXES", label: "Taxes" },
            { value: "CAISSIERS", label: "Caissiers" },
        ];
    } else if (typeReport == 3 || typeReport == 9) { // FACTURE && DUPLICATA FACTURE
        options = [
            { value: "", label: "Aucun" },
            { value: "LIGNES", label: "Lignes" },
            { value: "LIGNE_EXTRAS", label: "Ligne (Complément)" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "REGLEMENT_EXTRAS", label: "Règlement (Complément)" },
            { value: "TAXES", label: "Taxes" },
        ];
    } else if (typeReport == 4 || typeReport == 10) { // BON ACHAT && DUPLICATA BON ACHAT
        options = [
            { value: "", label: "Aucun" },
            { value: "LIGNES", label: "Lignes" },
            { value: "LIGNE_EXTRAS", label: "Ligne (Complément)" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "REGLEMENT_EXTRAS", label: "Règlement (Complément)" },
            { value: "TAXES", label: "Taxes" },
        ];
    } else if (typeReport == 6) { // Z CAISSE
        options = [
            { value: "", label: "Aucun" },
            { value: "CAISSE", label: "Caisse" },
            { value: "CAISSIERS", label: "Caissiers" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "TAXES", label: "Taxes" },
        ];
    } else if (typeReport == 11 || typeReport == 12) { // RECU DE PAIEMENT && DUPLICATA RECU DE PAIEMENT
        options = [
            { value: "", label: "Aucun" },
            { value: "LIGNES", label: "Lignes" },
            { value: "LIGNE_EXTRAS", label: "Ligne (Complément)" },
            { value: "REGLEMENTS", label: "Règlements" },
            { value: "REGLEMENT_EXTRAS", label: "Règlement (Complément)" },
            { value: "TAXES", label: "Taxes" },
        ];
    }
    return new DropdownList({
        defaultValue: "",
        items: options,
    });
}
*/

    function createFontSizeDropdownEditor() {
        return new DropdownList({
            defaultValue: "",
            items: [
                { value: "6px", label: "6" },
                { value: "7px", label: "7" },
                { value: "8px", label: "8" },
                { value: "9px", label: "9" },
                { value: "10px", label: "10" },
                { value: "11px", label: "11" },
                { value: "", label: "12" },
                { value: "13px", label: "13" },
                { value: "14px", label: "14" },
                { value: "15px", label: "15" },
                { value: "16px", label: "16" },
                { value: "17px", label: "17" },
                { value: "18px", label: "18" },
                { value: "19px", label: "19" },
                { value: "20px", label: "20" },
                { value: "21px", label: "21" },
                { value: "22px", label: "22" },
                { value: "23px", label: "23" },
                { value: "24px", label: "24" },
                { value: "25px", label: "25" },
                { value: "26px", label: "26" },
                { value: "27px", label: "27" },
                { value: "28px", label: "28" },
                { value: "29px", label: "29" },
                { value: "30px", label: "30" },
                { value: "31px", label: "31" },
                { value: "32px", label: "32" },
                { value: "33px", label: "33" },
                { value: "34px", label: "34" },
                { value: "35px", label: "35" },
                { value: "36px", label: "36" },
                { value: "37px", label: "37" },
                { value: "38px", label: "38" },
                { value: "39px", label: "39" },
                { value: "40px", label: "40" },
                { value: "41px", label: "41" },
                { value: "42px", label: "42" },
                { value: "43px", label: "43" },
                { value: "44px", label: "44" },
                { value: "45px", label: "45" },
                { value: "46px", label: "46" },
                { value: "47px", label: "47" },
                { value: "48px", label: "48" },
                { value: "49px", label: "49" },
                { value: "50px", label: "50" },
                { value: "51px", label: "51" },
                { value: "52px", label: "52" },
                { value: "53px", label: "53" },
                { value: "54px", label: "54" },
                { value: "55px", label: "55" },
                { value: "56px", label: "56" },
                { value: "57px", label: "57" },
                { value: "58px", label: "58" },
                { value: "59px", label: "59" },
                { value: "60px", label: "60" },
                { value: "61px", label: "61" },
                { value: "62px", label: "62" },
                { value: "63px", label: "63" },
                { value: "64px", label: "64" },
                { value: "65px", label: "65" },
                { value: "66px", label: "66" },
                { value: "67px", label: "67" },
                { value: "68px", label: "68" },
                { value: "69px", label: "69" },
                { value: "70px", label: "70" },
                { value: "71px", label: "71" },
                { value: "72px", label: "72" },
                { value: "73px", label: "73" },
                { value: "74px", label: "74" },
                { value: "75px", label: "75" },
                { value: "76px", label: "76" },
                { value: "77px", label: "77" },
                { value: "78px", label: "78" },
                { value: "79px", label: "79" },
                { value: "80px", label: "80" },
                { value: "81px", label: "81" },
                { value: "82px", label: "82" },
                { value: "83px", label: "83" },
                { value: "84px", label: "84" },
                { value: "85px", label: "85" },
                { value: "86px", label: "86" },
                { value: "87px", label: "87" },
                { value: "88px", label: "88" },
                { value: "89px", label: "89" },
                { value: "90px", label: "90" },
                { value: "91px", label: "91" },
                { value: "92px", label: "92" },
                { value: "93px", label: "93" },
                { value: "94px", label: "94" },
                { value: "95px", label: "95" },
                { value: "96px", label: "96" },
                { value: "97px", label: "97" },
                { value: "98px", label: "98" },
                { value: "99px", label: "99" },
            ],
        });
    }

    function createFontWeightDropdownEditor() {
        return new DropdownList({
            defaultValue: "",
            items: [
                { value: "", label: "Normal" },
                { value: "bold", label: "Bold" },
                //{ value: "lighter", label: "Lighter" },
                //{ value: "bolder", label: "Bolder" },
                /*{ value: "100", label: "100" },
                { value: "200", label: "200" },
                { value: "300", label: "300" },
                { value: "400", label: "400" },
                { value: "500", label: "500" },
                { value: "600", label: "600" },
                { value: "700", label: "700" },
                { value: "800", label: "800" },
                { value: "900", label: "900" },*/
            ],
        });
    }

    function createTextAlignDropdownEditor() {
        return new DropdownList({
            defaultValue: "Arial",
            items: [
                { value: "", label: "Left" },
                { value: "center", label: "Center" },
                { value: "right", label: "Right" },
            ],
        });
    }

    function createDropdownList(options, defaultValue) {
        return new DropdownList({
            defaultValue: !!defaultValue ? defaultValue : "",
            items: options,
        });
    }

    function createExpressionEditor(options, expressionValue) {
        return new ExpressionEditor(options, expressionValue);
    }

    class Properties {
        constructor() {
            this._cache = [];
            this._updating = false;
            this._changeEventEmitter = new EventEmitter();
        }
        emitOnChange(property, newValue, oldValue) {
            if (/*property != 'extraProperties' && */oldValue === newValue)
                return;
            this._cache.push({
                property,
                newValue,
                oldValue,
            });
            if (this._updating)
                return;
            this._emitOnChange();
        }
        _emitOnChange() {
            if (this._cache.length === 0)
                return;
            this._changeEventEmitter.emit({ changes: [...this._cache] });
            this._cache.length = 0;
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this._changeEventEmitter.add(listener);
                    break;
            }
        }
        removeEventListener(event, listener) {
            switch (event) {
                case "change":
                    this._changeEventEmitter.remove(listener);
                    break;
            }
        }
        beginUpdate() {
            this._updating = true;
        }
        endUpdate() {
            this._updating = false;
            this._emitOnChange();
        }
    }

    class StyleProperties extends Properties {
        constructor(defaultValues) {
            super();
            if (!defaultValues)
                return;
            this.beginUpdate();
            this._color = defaultValues.color;
            this._backgroundColor = defaultValues.backgroundColor;
            this._textAlign = defaultValues.textAlign;
            this._textMode = defaultValues.textMode;
            this._borderWidth = defaultValues.borderWidth;
            this._borderStyle = defaultValues.borderStyle;
            this._borderColor = defaultValues.borderColor;
            this._fontFamily = defaultValues.fontFamily;
            this._fontSize = defaultValues.fontSize;
            this._fontWeight = defaultValues.fontWeight;
            this._extraProperties = defaultValues.extraProperties || [];
            this.conditionsVisibility = defaultValues.conditionsVisibility ?? {};
            this.endUpdate();
        }
        get color() {
            return this._color;
        }
        get backgroundColor() {
            return this._backgroundColor;
        }
        get textAlign() {
            return this._textAlign;
        }
        get textMode() {
            return this._textMode;
        }
        get borderWidth() {
            return this._borderWidth;
        }
        get borderStyle() {
            return this._borderStyle;
        }
        get borderColor() {
            return this._borderColor;
        }
        get fontFamily() {
            return this._fontFamily;
        }
        get fontSize() {
            return this._fontSize;
        }
        get fontWeight() {
            return this._fontWeight;
        }
        get extraProperties() {
            return this._extraProperties;
        }
        get conditionsVisibility() {
            return this._conditionsVisibility;
        }
        set color(value) {
            const oldValue = this._color;
            this._color = value;
            this.emitOnChange("color", value, oldValue);
        }
        set backgroundColor(value) {
            const oldValue = this._backgroundColor;
            this._backgroundColor = value;
            this.emitOnChange("backgroundColor", value, oldValue);
        }
        set textAlign(value) {
            const oldValue = this._textAlign;
            this._textAlign = value;
            this.emitOnChange("textAlign", value, oldValue);
        }
        set textMode(value) {
            const oldValue = this._textMode;
            this._textMode = value;
            this.emitOnChange("textMode", value, oldValue);
        }
        set borderWidth(value) {
            const oldValue = this._borderWidth;
            this._borderWidth = value;
            this.emitOnChange("borderWidth", value, oldValue);
        }
        set borderStyle(value) {
            const oldValue = this._borderStyle;
            this._borderStyle = value;
            this.emitOnChange("borderStyle", value, oldValue);
        }
        set borderColor(value) {
            const oldValue = this._borderColor;
            this._borderColor = value;
            this.emitOnChange("borderColor", value, oldValue);
        }
        set fontFamily(value) {
            const oldValue = this._fontFamily;
            this._fontFamily = value;
            this.emitOnChange("fontFamily", value, oldValue);
        }
        set fontSize(value) {
            const oldValue = this._fontSize;
            this._fontSize = value;
            this.emitOnChange("fontSize", value, oldValue);
        }
        set fontWeight(value) {
            const oldValue = this._fontWeight;
            this._fontWeight = value;
            this.emitOnChange("fontWeight", value, oldValue);
        }
        set extraProperties(value) {
            const oldValue = this._extraProperties;
            this._extraProperties = value;
            this.emitOnChange("extraProperties", value, oldValue);
        }
        set conditionsVisibility(value) {
            const oldValue = this.conditionsVisibility;
            this._conditionsVisibility = value;
            this.emitOnChange("conditionsVisibility", value, oldValue);
        }
        getPropertyDefinitions(options) {
            return [
                {
                    field: "color",
                    label: "Color",
                    type: "string",
                    editor: new ColorPicker({ defaultValue: "#000000" }),
                },
                {
                    field: "backgroundColor",
                    label: "Background Color",
                    type: "string",
                    editor: new ColorPicker({ defaultValue: "#ffffff" }),
                },
                {
                    field: "textAlign",
                    label: "Text Align",
                    type: "string",
                    editor: createTextAlignDropdownEditor(),
                },
                {
                    field: "textMode",
                    label: "Text Mode",
                    type: "string",
                    editor: createTextModeDropdownEditor(),
                },
                { field: "borderWidth", label: "Border Width", type: "number" },
                {
                    field: "borderStyle",
                    label: "Border Style",
                    type: "string",
                    editor: createBorderStyleDropdownEditor(),
                },
                {
                    field: "borderColor",
                    label: "Border Color",
                    type: "string",
                    editor: new ColorPicker({ defaultValue: "#000000" }),
                },
                {
                    field: "fontFamily",
                    label: "Font Family",
                    type: "string",
                    editor: createFontFamilyDropdownEditor(),
                },
                {
                    field: "fontSize",
                    label: "Font Size",
                    type: "string",
                    editor: createFontSizeDropdownEditor(),
                },
                {
                    field: "fontWeight",
                    label: "Font Weight",
                    type: "string",
                    editor: createFontWeightDropdownEditor(),
                },
                ...(!!this._extraProperties ? this._extraProperties.map(p => {
                    if (p.type == "select") {
                        p.editor = new DropdownList({
                            defaultValue: p.defaultValue,
                            items: p.items,
                        });
                    }
                    return p;
                }) : []),
                { field: "conditionsVisibility", label: "Conditions de visibilité", type: "object", editor: createExpressionEditor(options, this.conditionsVisibility) },
            ];
        }
    }

    class ReportItemProperties extends StyleProperties {
        constructor() {
            super(...arguments);
            this._x = 0;
            this._y = 0;
            this._width = 0;
            this._height = 0;
            this._name = "";
            this._text = "";
            this._binding = "";
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        get width() {
            return this._width;
        }
        get height() {
            return this._height;
        }
        get name() {
            return this._name;
        }
        get text() {
            return this._text;
        }
        get binding() {
            return this._binding;
        }
        set x(value) {
            const oldValue = this.x;
            this._x = value;
            this.emitOnChange("x", value, oldValue);
        }
        set y(value) {
            const oldValue = this._y;
            this._y = value;
            this.emitOnChange("y", value, oldValue);
        }
        set width(value) {
            const oldValue = this.width;
            this._width = value;
            this.emitOnChange("width", value, oldValue);
        }
        set height(value) {
            const oldValue = this.height;
            this._height = value;
            this.emitOnChange("height", value, oldValue);
        }
        set name(value) {
            const oldValue = this.name;
            this._name = value;
            this.emitOnChange("name", value, oldValue);
        }
        set text(value) {
            const oldValue = this.text;
            this._text = value;
            this.emitOnChange("text", value, oldValue);
        }
        set binding(value) {
            const oldValue = this.binding;
            this._binding = value;
            this.emitOnChange("binding", value, oldValue);
        }
        getPropertyDefinitions(options) {
            return [
                { field: "x", label: "X", type: "number" },
                { field: "y", label: "Y", type: "number" },
                { field: "width", label: "Width", type: "number" },
                { field: "height", label: "Height", type: "number" },
                { field: "name", label: "Name", type: "string" },
                { field: "text", label: "Text", type: "string" },
                { field: "binding", label: "Binding", type: "string" },
                ...super.getPropertyDefinitions(options),
            ];
        }
    }

    class ReportItem {
        constructor(options) {
            this.element = document.createElement("div");
            this.properties = new ReportItemProperties();
            if (!!options.extraProperties) {
                this.properties.extraProperties = options.extraProperties;
                for (var p in options.extraProperties) {
                    this.properties[options.extraProperties[p].field] = options.extraProperties[p].value;
                }
            }
            this.type = options.type || "string";
            this.fixedWidth = options.fixedWidth || false;
            this.fixedHeight = options.fixedHeight || false;
            this.hiddenProperties = options.hiddenProperties || [];
            this._changeEventEmitter = new EventEmitter();
            if (options.appendTo) {
                options.appendTo.appendChild(this.element);
            }
            if (options.prependTo) {
                if (options.prependTo.children.length > 0) {
                    options.prependTo.insertBefore(this.element, options.prependTo.children[0])
                } else {
                    options.prependTo.appendChild(this.element);
                }
            }
            this._styles = new MultipleStyles(...options.parentStyles, this.properties);
            if (options.defaultProperties) {
                this.loadLayout(options.defaultProperties);
            }
            this._init();
        }
        _init() {
            this.element.tabIndex = 0;
            this.element.style.display = "inline-block";
            this.element.style.position = "absolute";
            this.element.style.userSelect = "none";
            this.element.style.outline = "none";
            this.element.style.whiteSpace = "nowrap";
            this.element.style.overflow = "hidden";
            this.element.style.textOverflow = "ellipsis";
            this._styles.getList().forEach((styles) => {
                styles.addEventListener("change", () => this.refresh());
            });
            this.properties.addEventListener("change", (e) => this._onChange(e));
            this.refresh();
        }
        refresh() {
            this.element.style.left = `${this.properties.x}px`;
            this.element.style.top = `${this.properties.y}px`;
            this.element.style.width = `${this.properties.width}px`;
            this.element.style.height = `${this.properties.height}px`;
            this.element.innerText = this.properties.text;
            this.element.style.color = this._styles.getStyle("color", "");
            this.element.style.backgroundColor = this._styles.getStyle("backgroundColor", "");
            this.element.style.textAlign = this._styles.getStyle("textAlign", "");
            this.element.style.textMode = this._styles.getStyle("textMode", "");
            this.element.style.borderWidth =
                this._styles.getStyle("borderWidth", "0") + "px";
            this.element.style.borderStyle = this._styles.getStyle("borderStyle", "");
            this.element.style.borderColor = this._styles.getStyle("borderColor", "#000000");
            this.element.style.fontFamily = this._styles.getStyle("fontFamily", "Tahoma");
            this.element.style.fontSize = this._styles.getStyle("fontSize", "12px");
            this.element.style.fontWeight = this._styles.getStyle("fontWeight", "");
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    const callbackOnChange = listener;
                    this._changeEventEmitter.add(callbackOnChange);
                    break;
                case "focus":
                    const callbackOnFocus = listener;
                    this.element.addEventListener("focus", () => callbackOnFocus(undefined));
                    break;
            }
        }
        dispose() {
            this.element.remove();
        }
        loadLayout(layout) {
            var _a, _b, _c, _d, _e, _f;
            this.properties.beginUpdate();
            this.properties.x = (_a = layout.x) !== null && _a !== void 0 ? _a : 0;
            this.properties.y = (_b = layout.y) !== null && _b !== void 0 ? _b : 0;
            this.properties.width = (_c = layout.width) !== null && _c !== void 0 ? _c : 0;
            this.properties.height = (_d = layout.height) !== null && _d !== void 0 ? _d : 0;
            this.properties.name = (_e = layout.name) !== null && _e !== void 0 ? _e : "";
            this.properties.text = (_f = layout.text) !== null && _f !== void 0 ? _f : "";
            this.properties.binding = layout.binding || "";
            this.properties.color = layout.color;
            this.properties.backgroundColor = layout.backgroundColor;
            this.properties.textAlign = layout.textAlign;
            this.properties.textMode = layout.textMode;
            this.properties.borderWidth = layout.borderWidth;
            this.properties.borderStyle = layout.borderStyle;
            this.properties.borderColor = layout.borderColor;
            this.properties.fontFamily = layout.fontFamily;
            this.properties.fontSize = layout.fontSize;
            this.properties.fontWeight = layout.fontWeight;
            this.properties.conditionsVisibility = layout.conditionsVisibility;
            this.properties.endUpdate();
            this.refresh();
        }
        toJSON() {
            let result = {
                x: this.properties.x,
                y: this.properties.y,
                width: this.properties.width,
                height: this.properties.height,
                name: this.properties.name,
                text: this.properties.text,
                binding: this.properties.binding,
                color: this.properties.color,
                backgroundColor: this.properties.backgroundColor,
                textAlign: this.properties.textAlign,
                textMode: this.properties.textMode,
                borderWidth: this.properties.borderWidth,
                borderStyle: this.properties.borderStyle,
                borderColor: this.properties.borderColor,
                fontFamily: this.properties.fontFamily,
                fontSize: this.properties.fontSize,
                fontWeight: this.properties.fontWeight,
                extraProperties: this.properties.extraProperties,
                type: this.type,
                fixedWidth: this.fixedWidth,
                fixedHeight: this.fixedHeight,
                conditionsVisibility: this.properties.conditionsVisibility,
            };
            for (var e in this.properties.extraProperties) {
                if (!!this.properties.extraProperties[e].field && !!this.properties[this.properties.extraProperties[e].field]) {
                    this.properties.extraProperties[e]['value'] = this.properties[this.properties.extraProperties[e].field];
                }
            }
            return result;
        }
        _onChange(args) {
            this._changeEventEmitter.emit(args);
        }
    }

    // #region TABLE COMPONENT 
    /**
     * @typedef {Object} TableDOMHelperCell
     * @property {NodeElement | string} element
     * @property {Object?} style
     * @property {Object?} wrapperStyle
     * @property {number?} colSpan
     */
    class TableDOMHelper {
        constructor() {
            this.element = document.createElement("table");
            this.element.setAttribute('class', 'ankareport-table-comp-table');
            this.element.style.width = '100%';
            this.element.style.height = '100%';

            this._headersDomElements = [];
            this._rowsDomElements = [];
        }

        /**
         * @param {TableDOMHelperCell[]} headers
         */
        addHeader(...headers) {
            const headersDOM = [];
            for (var h in headers) {
                const headerDOM = this._createTableHeader(headers[h]);
                if (!!headers[h].wrapperStyle) { Object.keys(headers[h].wrapperStyle).forEach(ws => headerDOM.style[ws] = headers[h].wrapperStyle[ws]); }
                if (!!headers[h].colSpan) { headerDOM.colSpan = headers[h].colSpan; }
                headersDOM.push(headerDOM);
            }
            const rowHeaderDOM = this._createTableRow(headersDOM);
            this.element.appendChild(rowHeaderDOM);
        }

        /**
         * @param {{ width?: number, height?: number }} domStyle
         * @param {TableDOMHelperCell[]} cells
         */
        addHeaderWithStyle(domStyle, ...cells) {
            const headersDOM = [];
            for (var h in cells) {
                const headerDOM = this._createTableHeader(cells[h]);
                if (!!cells[h].wrapperStyle) { Object.keys(cells[h].wrapperStyle).forEach(ws => { headerDOM.style[ws] = cells[h].wrapperStyle[ws]; }); }
                if (!!cells[h].colSpan) { headerDOM.colSpan = cells[h].colSpan; }
                headersDOM.push(headerDOM);
            }
            const rowHeaderDOM = this._createTableRow(headersDOM);
            Object.keys(domStyle).forEach(s => { rowHeaderDOM.style[s] = domStyle[s]; });
            this.element.appendChild(rowHeaderDOM);
        }

        /**
         * @param {TableDOMHelperCell[]} cells
         */
        addRow(...cells) {
            const cellsDOM = [];
            for (var c in cells) {
                const cellDOM = this._createTableCell(cells[c]);
                if (!!cells[c].wrapperStyle) { Object.keys(cells[c].wrapperStyle).forEach(ws => { cellDOM.style[ws] = cells[c].wrapperStyle[ws]; }); }
                if (!!cells[c].colSpan) { cellDOM.colSpan = cells[c].colSpan; }
                cellsDOM.push(cellDOM);
            }
            const rowCellsDOM = this._createTableRow(cellsDOM);
            this.element.appendChild(rowCellsDOM);
        }

        /**
         * @param {{ width?: number, height?: number }} domStyle
         * @param {TableDOMHelperCell[]} cells
         */
        addRowWithStyle(domStyle, ...cells) {
            const cellsDOM = [];
            for (var c in cells) {
                const cellDOM = this._createTableCell(cells[c]);
                if (!!cells[c].wrapperStyle) { Object.keys(cells[c].wrapperStyle).forEach(ws => { cellDOM.style[ws] = cells[c].wrapperStyle[ws]; }); }
                if (!!cells[c].colSpan) { cellDOM.colSpan = cells[c].colSpan; }
                cellsDOM.push(cellDOM);
            }
            const rowCellsDOM = this._createTableRow(cellsDOM);
            Object.keys(domStyle).forEach(s => { rowCellsDOM[s] = domStyle[s]; });
            this.element.appendChild(rowCellsDOM);
        }

        /**
         * @param {TableDOMHelperCell} cell
         */
        _createTableHeader(cell) {
            const headerDOM = document.createElement('th');
            headerDOM.setAttribute('class', 'ankareport-table-comp-theader');
            if (!!cell.style) { Object.keys(cell.style).forEach(s => { headerDOM.style[s] = cell.style[s]; }); }
            if (cell.element instanceof Node) {
                headerDOM.appendChild(cell.element);
            } else {
                headerDOM.innerText = cell.element;
            }
            return headerDOM;
        }

        /**
         * @param {HTMLTableCellElement[]} cells
         */
        _createTableRow(cells) {
            const rowDOM = document.createElement('tr');
            rowDOM.setAttribute('class', 'ankareport-table-comp-trow');
            for (const cell of cells) {
                rowDOM.appendChild(cell);
            }
            return rowDOM;
        }

        /**
         * @param {TableDOMHelperCell} cell
         */
        _createTableCell(cell) {
            const cellDOM = document.createElement('td');
            cellDOM.setAttribute('class', 'ankareport-table-comp-tcell');
            if (!!cell.style) { Object.keys(cell.style).forEach(s => { cellDOM.style[s] = cell.style[s]; }); }
            if (cell.element instanceof Node) {
                cellDOM.appendChild(cell.element);
            } else {
                cellDOM.innerText = cell.element;
            }
            return cellDOM;
        }
    }

    class TableReportColumnsPropertiesEditor {
        constructor(options) {
            this.element = document.createElement("div");
            this.options = options;
            this._columns = options.columns;
            this.areaSelector = new AreaSelector({
                area: this.element,
            });
            this.refresh();
        }
        get columns() {
            return this._columns;
        }
        get value() {
            if (this.element.value === this.options.defaultValue) {
                return [];
            }
            return this.element.value;
        }
        set value(value) {
            if (!value) {
                this.element.value = this.options.defaultValue;
            }
            else {
                this.element.value = value;
            }
        }
        set columns(value) {
            this._columns = value;
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.element.addEventListener("change", () => {
                        listener({ value: this.value });
                    });
                    break;
            }
        }

        refresh() {
            this.element.innerHTML = '';

            const editButton = document.createElement("button");
            editButton.setAttribute('type', 'button');
            editButton.classList.add("anka-toolbar-button");
            const pencilIcon = document.createElement('img');
            pencilIcon.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3klEQVR4nO2VMQrCMBSGPwV38SIWBPESHkAv4iYdHDyCB3CsvUBXZ+3uFfQAHWIk8AqhTWsT6CD1hx9KePm/vJCk8GOaACfgAWz7AEyBG6AFUlME5MBbirTDCjg7Vr6S75lATCc15S3B2vKzEp4CBbC2OjHjNSkJuALHBh+ARSW8BBdWJ06VhXFbUUO48aVp5b6AsSM8/RbuA9iEhPsAkpBwX0AinYxkbAm8HEc4CODS3ronvQBia/4fMGSAkoIM2Hk663JM7x2fa91i8y9oVCQFZSfaw0rmzgO2lwHrAw93lpIXQy35AAAAAElFTkSuQmCC");
            editButton.appendChild(pencilIcon);

            const htmlString = `<div class="form-group">
                                    <label for="exampleInputEmail1">Libellé</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1">
                                </div>`;
            const template = document.createElement('template');
            template.innerHTML = htmlString.trim();
            const node = template.content.firstChild;

            const tableDOMHelper = new TableDOMHelper();
            tableDOMHelper.addHeader({ element: "Colonnes" }, { element: "Actions" });
            this._columns.forEach((column, index) => {
                const editButtonColumn = editButton.cloneNode(true);
                editButtonColumn.id = "anka-table-btn-edit-" + index;
                editButtonColumn.addEventListener("click", () => {
                    this.showModal('Modification de colonne ' + (index + 1), node);
                });
                tableDOMHelper.addRow({ element: column.title }, { element: editButtonColumn });
            });

            const actionButton = document.createElement("button");
            actionButton.setAttribute('type', 'button');
            actionButton.classList.add("anka-toolbar-button");
            actionButton.innerText = 'Ajouter une colonne'
            actionButton.addEventListener("click", () => {
                this.showModal('Ajout de colonne ', node);
            });
            tableDOMHelper.addRow({ element: actionButton, colSpan: this._columns.length });

            this.element.appendChild(tableDOMHelper.element);
        }

        showModal(title, contentEls) {
            // Créer l'overlay
            const overlay = document.createElement('div');
            overlay.style.position = 'fixed';
            overlay.style.top = 0;
            overlay.style.left = 0;
            overlay.style.width = '100vw';
            overlay.style.height = '100vh';
            overlay.style.background = 'rgba(0,0,0,0.5)';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';
            overlay.style.zIndex = 10000;

            // Créer le contenu du modal
            const modal = document.createElement('div');
            modal.style.background = '#fff';
            modal.style.padding = '16px';
            modal.style.borderRadius = '8px';
            modal.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
            modal.innerHTML = `<div>
                                    <h4 id="anka-report-table-column-modal-header">${title}</h4>
                                    <div id="anka-report-table-column-modal-body"></div>
                                    <div id="anka-report-table-column-modal-footer">
                                        <button class="btn btn-primary" id="btn-confirm">Valider</button>
                                        <button class="btn" id="btn-dismiss">Annuler</button>
                                    </div>
                                </div>`;
            const modalBody = modal.querySelector('#anka-report-table-column-modal-body');
            modalBody.appendChild(contentEls);

            // Bouton de fermeture
            const closeBtn = modal.querySelector('#btn-dismiss');
            closeBtn.onclick = () => document.body.removeChild(overlay);

            const confirmBtn = modal.querySelector('#btn-confirm');
            confirmBtn.onclick = () => document.body.removeChild(overlay);

            overlay.appendChild(modal);
            document.body.appendChild(overlay);
        }
    }

    class TableReportItemProperties extends Properties {
        constructor(defaultValues) {
            super();

            this.beginUpdate();
            this._x = 0;
            this._y = 0;
            this._width = 0;
            this._height = 0;
            this._name = "";
            this._binding = "";
            this._borderWidth = defaultValues?.borderWidth || 1;
            this._borderStyle = defaultValues?.borderStyle || 'none';
            this._borderColor = defaultValues?.borderColor || '#000000';
            this._columns = [
                { title: 'Colonne 1' },
                { title: 'Colonne 2' },
                { title: 'Colonne 3' },
            ];
            this.endUpdate();

        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        get width() {
            return this._width;
        }
        get height() {
            return this._height;
        }
        get name() {
            return this._name;
        }
        get binding() {
            return this._binding;
        }
        get borderWidth() {
            return this._borderWidth;
        }
        get borderStyle() {
            return this._borderStyle;
        }
        get borderColor() {
            return this._borderColor;
        }
        get columns() {
            return this._columns;
        }
        set x(value) {
            const oldValue = this.x;
            this._x = value;
            this.emitOnChange("x", value, oldValue);
        }
        set y(value) {
            const oldValue = this._y;
            this._y = value;
            this.emitOnChange("y", value, oldValue);
        }
        set width(value) {
            const oldValue = this.width;
            this._width = value;
            this.emitOnChange("width", value, oldValue);
        }
        set height(value) {
            const oldValue = this.height;
            this._height = value;
            this.emitOnChange("height", value, oldValue);
        }
        set name(value) {
            const oldValue = this.name;
            this._name = value;
            this.emitOnChange("name", value, oldValue);
        }
        set binding(value) {
            const oldValue = this.binding;
            this._binding = value;
            this.emitOnChange("binding", value, oldValue);
        }
        set borderWidth(value) {
            const oldValue = this._borderWidth;
            this._borderWidth = value;
            this.emitOnChange("borderWidth", value, oldValue);
        }
        set borderStyle(value) {
            const oldValue = this._borderStyle;
            this._borderStyle = value;
            this.emitOnChange("borderStyle", value, oldValue);
        }
        set borderColor(value) {
            const oldValue = this._borderColor;
            this._borderColor = value;
            this.emitOnChange("borderColor", value, oldValue);
        }
        set columns(value) {
            const oldValue = this._columns;
            this._columns = value;
            this.emitOnChange("columns", value, oldValue);
        }
        getPropertyDefinitions(options) {
            return [
                { field: "x", label: "X", type: "number" },
                { field: "y", label: "Y", type: "number" },
                { field: "width", label: "Width", type: "number" },
                { field: "height", label: "Height", type: "number" },
                { field: "name", label: "Name", type: "string" },
                { field: "binding", label: "Binding", type: "string" },
                { field: "borderWidth", label: "Border Width", type: "number" },
                { field: "borderStyle", label: "Border Style", type: "string", editor: createBorderStyleDropdownEditor() },
                { field: "borderColor", label: "Border Color", type: "string", editor: new ColorPicker({ defaultValue: "#000000" }) },
                { field: "columns", label: "Colonnes", type: "string", editor: new TableReportColumnsPropertiesEditor({ columns: this._columns }) },
            ];
        }
    }

    class TableReportItemComponent {
        constructor(options) {
            this.element = document.createElement("div");
            this.properties = new TableReportItemProperties();
            this._changeEventEmitter = new EventEmitter();
            if (options.appendTo) {
                options.appendTo.appendChild(this.element);
            }
            if (options.prependTo) {
                if (options.prependTo.children.length > 0) {
                    options.prependTo.insertBefore(this.element, options.prependTo.children[0])
                } else {
                    options.prependTo.appendChild(this.element);
                }
            }
            this._styles = new MultipleStyles(...options.parentStyles, this.properties);
            if (options.defaultProperties) {
                this.loadLayout(options.defaultProperties);
            }
            this._init();

            this.element.style.cursor = "pointer";
        }

        handleFocusEvent(e) {
            //console.log(e);
            return false;
        }

        _init() {
            this.element.tabIndex = 0;
            this.element.style.display = "inline-block";
            this.element.style.position = "absolute";
            this.element.style.userSelect = "none";
            this.element.style.outline = "none";
            this.element.style.whiteSpace = "nowrap";
            this.element.style.overflow = "hidden";
            this.element.style.textOverflow = "ellipsis";
            this._styles.getList().forEach((styles) => {
                styles.addEventListener("change", () => this.refresh());
            });
            this.properties.addEventListener("change", (e) => this._onChange(e));
            this.refresh();
        }

        refresh() {
            this.element.style.left = `${this.properties.x}px`;
            this.element.style.top = `${this.properties.y}px`;
            this.element.style.width = `${this.properties.width}px`;
            this.element.style.height = `${this.properties.height}px`;
            this.element.style.borderWidth = this._styles.getStyle("borderWidth", "0") + "px";
            this.element.style.borderStyle = this._styles.getStyle("borderStyle", "");
            this.element.style.borderColor = this._styles.getStyle("borderColor", "#000000");

            const tableActionElement = document.createElement('div');
            tableActionElement.setAttribute('class', 'ankareport-table-action ankareport-table-item');

            const headerActionElement = document.createElement('div');
            headerActionElement.setAttribute('class', 'ankareport-table-header-action ankareport-table-item');

            const rowActionElement = document.createElement('div');
            rowActionElement.setAttribute('class', 'ankareport-table-row-action ankareport-table-item');

            const tableDOMHelper = new TableDOMHelper();
            tableDOMHelper.addHeader(
                { element: tableActionElement.cloneNode(true), style: { width: 17 }, wrapperStyle: { width: '17px' } },
                { element: headerActionElement.cloneNode(true) },
                { element: headerActionElement.cloneNode(true) },
                { element: headerActionElement.cloneNode(true) }
            );
            tableDOMHelper.addHeader(
                { element: rowActionElement.cloneNode(true), style: { width: 17 } },
                { element: "Colonne 1", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333", } },
                { element: "Colonne 2", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333" } },
                { element: "Colonne 3", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333" } }
            );
            tableDOMHelper.addRowWithStyle(
                { width: 17 },
                { element: rowActionElement.cloneNode(true) },
                { element: "Text 1", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333" } },
                { element: "Text 2", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333" } },
                { element: "Text 3", wrapperStyle: { borderWidth: "1px", borderStyle: "solid", borderColor: "#333" } }
            );
            this.tableDOMElement = tableDOMHelper.element;
            this.element.appendChild(this.tableDOMElement);
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    const callbackOnChange = listener;
                    this._changeEventEmitter.add(callbackOnChange);
                    break;
                case "focus": {
                    const callbackOnFocus = listener;
                    this.element.addEventListener("focus", (e) => {
                        callbackOnFocus(e);
                    });
                }
                    break;
                case "select": {
                    const callbackOnFocus = listener;
                    this.element.addEventListener('click', (e) => {
                        console.log(e.target, e.currentTarget);
                    });
                    /*this.element.querySelectorAll('.ankareport-table-item').forEach(i => {
                        i.addEventListener('click', (e) => {
                            if (!i.classList.contains('selected')) {
                                i.classList.add('selected');
                                //this._changeEventEmitter.emit("select");
                                callbackOnFocus(e);
                            }
                        });
                    });*/
                }
                    break;
            }
        }
        dispose() {
            this.element.remove();
        }
        loadLayout(layout) {
            var _a, _b, _c, _d, _e, _f;
            this.properties.beginUpdate();
            this.properties.x = (_a = layout.x) !== null && _a !== void 0 ? _a : 0;
            this.properties.y = (_b = layout.y) !== null && _b !== void 0 ? _b : 0;
            this.properties.width = (_c = layout.width) !== null && _c !== void 0 ? _c : 0;
            this.properties.height = (_d = layout.height) !== null && _d !== void 0 ? _d : 0;
            this.properties.name = (_e = layout.name) !== null && _e !== void 0 ? _e : "";
            this.properties.binding = layout.binding || "";
            this.properties.borderWidth = layout.borderWidth;
            this.properties.borderStyle = layout.borderStyle;
            this.properties.borderColor = layout.borderColor;
            this.properties.endUpdate();
            this.refresh();
        }
        toJSON() {
            let result = {
                x: this.properties.x,
                y: this.properties.y,
                width: this.properties.width,
                height: this.properties.height,
                name: this.properties.name,
                binding: this.properties.binding,
                borderWidth: this.properties.borderWidth,
                borderStyle: this.properties.borderStyle,
                borderColor: this.properties.borderColor,
            };
            return result;
        }
        _onChange(args) {
            this._changeEventEmitter.emit(args);
        }
    }
    // #endregion

    class DesignerReportItem extends ReportItem {
        constructor(options) {
            super(options);
            this.element.style.cursor = "pointer";
        }
        refresh() {
            super.refresh();
            if (this.properties.binding) {
                if (this.properties.binding == "CLU|FUNCTION|IMAGE") {
                    this.element.innerText = '';
                    const DOM_img = document.createElement("img");
                    DOM_img.src = !!this.properties.IMG_SRC ? this.properties.IMG_SRC : icon_image_placeholder;
                    DOM_img.style.width = '100%';
                    DOM_img.style.height = '100%';
                    this.element.appendChild(DOM_img);
                } else if (this.properties.binding == "CLU|FUNCTION|BARCODE") {
                    this.element.innerText = '';
                    const DOM_img = document.createElement("img");
                    DOM_img.src = icon_barcode_placeholder;
                    DOM_img.style.width = '100%';
                    DOM_img.style.height = '100%';
                    this.element.appendChild(DOM_img);
                } else if (this.properties.binding == "CLU|FUNCTION|QRCODE") {
                    this.element.innerText = '';
                    const DOM_img = document.createElement("img");
                    DOM_img.src = icon_qrcode_placeholder;
                    DOM_img.style.width = '100%';
                    DOM_img.style.height = '100%';
                    this.element.appendChild(DOM_img);
                } else if (this.properties.binding == "CLU|FUNCTION|LINE") {
                    this.element.innerText = '';
                    this.element.width = '100%';
                    this.element.height = '100%';
                    this.element.style.background = this._styles.getStyle("color", '#000000');
                } else if (this.properties.binding == "CLU|FUNCTION|VLINE") {
                    this.element.innerText = '';
                    this.element.width = '100%';
                    this.element.height = '100%';
                    this.element.style.background = this._styles.getStyle("color", '#000000');
                } else if (this.properties.binding == "CLU|FUNCTION|RECTANGLE") {
                    this.element.innerText = '';
                    this.element.width = '100%';
                    this.element.height = '100%';
                    this.element.style.background = this.element.style.background || '#FFFFFF';
                } else {
                    let display = this.properties.text;
                    let bindingArr = this.properties.binding.split('|');
                    if (bindingArr.length == 3) {
                        display = bindingArr[2];
                    }
                    this.element.innerText = `@[${display}]`;
                }
            }
            if (this.properties.conditionsVisibility) {
                const countConditions = AnkaConditionGroupProperty.countConditionsVisibility(this.properties.conditionsVisibility).conditions;
                if (countConditions > 0) {
                    this.element.style.border = "2px dashed #3448fbff";
                }
            } else {
                this.element.style.border = this.element.style.border || "1px solid #cccccc";
            }
            
        }
    }

    class Size {
        constructor(width, height, onchange) {
            this.onchange = onchange;
            this._width = 0;
            this._height = 0;
            if (width)
                this._width = width;
            if (height)
                this._height = height;
        }
        get width() {
            return this._width;
        }
        set width(value) {
            this._width = value;
            if (this.onchange)
                this.onchange();
        }
        get height() {
            return this._height;
        }
        set height(value) {
            this._height = value;
            if (this.onchange)
                this.onchange();
        }
    }

    const NORMALIZE_POINT_TOLERANCE_PX = 3;
    function normalizePoints(edges, selector, items) {
        const isMoving = edges.left && edges.right && edges.top && edges.bottom;
        const normalizedPoints = {
            left: selector.newLocation.x,
            top: selector.newLocation.y,
            right: selector.newLocation.x + selector.newSize.width,
            bottom: selector.newLocation.y + selector.newSize.height,
        };
        items.forEach((item) => {
            const left = item.properties.x;
            const right = left + item.properties.width;
            const top = item.properties.y;
            const bottom = top + item.properties.height;
            // TOP
            // Item Top
            if (edges.top &&
                Math.abs(normalizedPoints.top - top) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.top = top;
                if (isMoving) {
                    normalizedPoints.bottom = top + selector.newSize.height;
                }
            }
            // Item Bottom
            if (edges.top &&
                Math.abs(normalizedPoints.top - bottom) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.top = bottom;
                if (isMoving) {
                    normalizedPoints.bottom = bottom + selector.newSize.height;
                }
            }
            // BOTTOM
            // Item Bottom
            if (edges.bottom &&
                Math.abs(normalizedPoints.bottom - bottom) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.bottom = bottom;
                if (isMoving) {
                    normalizedPoints.top = bottom - selector.newSize.height;
                }
            }
            // Item Top
            if (edges.bottom &&
                Math.abs(normalizedPoints.bottom - top) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.bottom = top;
                if (isMoving) {
                    normalizedPoints.top = top - selector.newSize.height;
                }
            }
            // LEFT
            // Item Left
            if (edges.left &&
                Math.abs(normalizedPoints.left - left) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.left = left;
                if (isMoving) {
                    normalizedPoints.right = left + selector.newSize.width;
                }
            }
            // Item Right
            if (edges.left &&
                Math.abs(normalizedPoints.left - right) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.left = right;
                if (isMoving) {
                    normalizedPoints.right = right + selector.newSize.width;
                }
            }
            // RIGHT
            // Item Right
            if (edges.right &&
                Math.abs(normalizedPoints.right - right) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.right = right;
                if (isMoving) {
                    normalizedPoints.left = right - selector.newSize.width;
                }
            }
            // Item Left
            if (edges.right &&
                Math.abs(normalizedPoints.right - left) <= NORMALIZE_POINT_TOLERANCE_PX) {
                normalizedPoints.right = left;
                if (isMoving) {
                    normalizedPoints.left = left - selector.newSize.width;
                }
            }
        });
        return normalizedPoints;
    }

    var SelectorBoundOrientation;
    (function (SelectorBoundOrientation) {
        SelectorBoundOrientation["TopLeft"] = "top-left";
        SelectorBoundOrientation["TopCenter"] = "top-center";
        SelectorBoundOrientation["TopRight"] = "top-right";
        SelectorBoundOrientation["MiddleLeft"] = "middle-left";
        SelectorBoundOrientation["MiddleRight"] = "middle-right";
        SelectorBoundOrientation["BottomLeft"] = "bottom-left";
        SelectorBoundOrientation["BottomCenter"] = "bottom-center";
        SelectorBoundOrientation["BottomRight"] = "bottom-right";
    })(SelectorBoundOrientation || (SelectorBoundOrientation = {}));
    class SelectorBound {
        constructor(orientation) {
            this.orientation = orientation;
            this.element = document.createElement("div");
            this.init();
        }
        init() {
            this.element.classList.add("anka-selector-bound");
            this.element.classList.add(this.orientation);
        }
    }

    const LONG_MOVE_DISTANCE = 10;
    const SHORT_MOVE_DISTANCE = 1;
    class ReportItemSelector {
        constructor(mouseMoveContainer) {
            this.mouseMoveContainer = mouseMoveContainer;
            this.element = document.createElement("div");
            this.attachedTo = [];
            this.boundTL = new SelectorBound(SelectorBoundOrientation.TopLeft);
            this.boundTC = new SelectorBound(SelectorBoundOrientation.TopCenter);
            this.boundTR = new SelectorBound(SelectorBoundOrientation.TopRight);
            this.boundML = new SelectorBound(SelectorBoundOrientation.MiddleLeft);
            this.boundMR = new SelectorBound(SelectorBoundOrientation.MiddleRight);
            this.boundBL = new SelectorBound(SelectorBoundOrientation.BottomLeft);
            this.boundBC = new SelectorBound(SelectorBoundOrientation.BottomCenter);
            this.boundBR = new SelectorBound(SelectorBoundOrientation.BottomRight);
            this.originalLocation = new Point();
            this.originalSize = new Size();
            this.newLocation = new Point();
            this.newSize = new Size();
            this.init();
        }
        init() {
            this.onKeyDown = this.onKeyDown.bind(this);
            this.onItemPropertyChange = this.onItemPropertyChange.bind(this);
            this.element.classList.add("anka-report-item-selector");
            this.element.appendChild(this.boundTL.element);
            this.element.appendChild(this.boundTC.element);
            this.element.appendChild(this.boundTR.element);
            this.element.appendChild(this.boundML.element);
            this.element.appendChild(this.boundMR.element);
            this.element.appendChild(this.boundBL.element);
            this.element.appendChild(this.boundBC.element);
            this.element.appendChild(this.boundBR.element);
            this.element.tabIndex = -1;
            this.hide();
            this.initMoveDragDrop();
            this.initBoundsDragDrop();
        }
        initMoveDragDrop() {
            new DragDrop({
                element: this.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.x = this.originalLocation.x + e.offsetX;
                    this.newLocation.y = this.originalLocation.y + e.offsetY;
                    this.normalize({ left: true, right: true, top: true, bottom: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
        }
        initBoundsDragDrop() {
            // Top Left
            new DragDrop({
                element: this.boundTL.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.x = this.originalLocation.x + e.offsetX;
                    this.newLocation.y = this.originalLocation.y + e.offsetY;
                    this.newSize.width = this.originalSize.width - e.offsetX;
                    this.newSize.height = this.originalSize.height - e.offsetY;
                    this.normalize({ top: true, left: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Top Center
            new DragDrop({
                element: this.boundTC.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.y = this.originalLocation.y + e.offsetY;
                    this.newSize.height = this.originalSize.height - e.offsetY;
                    this.normalize({ top: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Top Right
            new DragDrop({
                element: this.boundTR.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.y = this.originalLocation.y + e.offsetY;
                    this.newSize.width = this.originalSize.width + e.offsetX;
                    this.newSize.height = this.originalSize.height - e.offsetY;
                    this.normalize({ top: true, right: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Middle Left
            new DragDrop({
                element: this.boundML.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.x = this.originalLocation.x + e.offsetX;
                    this.newSize.width = this.originalSize.width - e.offsetX;
                    this.normalize({ left: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Middle Right
            new DragDrop({
                element: this.boundMR.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newSize.width = this.originalSize.width + e.offsetX;
                    this.normalize({ right: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Bottom Left
            new DragDrop({
                element: this.boundBL.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newLocation.x = this.originalLocation.x + e.offsetX;
                    this.newSize.width = this.originalSize.width - e.offsetX;
                    this.newSize.height = this.originalSize.height + e.offsetY;
                    this.normalize({ bottom: true, left: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Bottom Center
            new DragDrop({
                element: this.boundBC.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newSize.height = this.originalSize.height + e.offsetY;
                    this.normalize({ bottom: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
            // Bottom Right
            new DragDrop({
                element: this.boundBR.element,
                container: this.mouseMoveContainer.element,
                onMouseMove: (e) => {
                    this.newSize.width = this.originalSize.width + e.offsetX;
                    this.newSize.height = this.originalSize.height + e.offsetY;
                    this.normalize({ bottom: true, right: true });
                    this.refresh();
                },
                onMouseUp: () => this.applyInfoToElement(),
            });
        }
        onKeyDown(e) {
            const moveDistance = e.shiftKey ? SHORT_MOVE_DISTANCE : LONG_MOVE_DISTANCE;
            switch (e.key) {
                case "ArrowUp":
                    this.newLocation.y -= moveDistance;
                    this.applyInfoToElement();
                    break;
                case "ArrowDown":
                    this.newLocation.y += moveDistance;
                    this.applyInfoToElement();
                    break;
                case "ArrowLeft":
                    this.newLocation.x -= moveDistance;
                    this.applyInfoToElement();
                    break;
                case "ArrowRight":
                    this.newLocation.x += moveDistance;
                    this.applyInfoToElement();
                    break;
            }
        }
        normalize(edges) {
            const normalizedPoints = normalizePoints(edges, this, this.mouseMoveContainer.items);
            this.newLocation.x = normalizedPoints.left;
            this.newLocation.y = normalizedPoints.top;
            this.newSize.width = normalizedPoints.right - normalizedPoints.left;
            this.newSize.height = normalizedPoints.bottom - normalizedPoints.top;
        }
        refresh() {
            this.element.style.left = this.newLocation.x + "px";
            this.element.style.top = this.newLocation.y + "px";
            this.element.style.width = this.newSize.width + "px";
            this.element.style.height = this.newSize.height + "px";
        }
        show(items) {
            if (this.attachedTo.length > 0) {
                this.hide();
            }
            this.attachedTo = [...items];
            const maxX = Math.max(...items.map((i) => i.properties.x + i.properties.width));
            const maxY = Math.max(...items.map((i) => i.properties.y + i.properties.height));
            this.originalLocation.x = Math.min(...items.map((i) => i.properties.x));
            this.originalLocation.y = Math.min(...items.map((i) => i.properties.y));
            this.originalSize.width = maxX - this.originalLocation.x;
            this.originalSize.height = maxY - this.originalLocation.y;
            this.newLocation.x = this.originalLocation.x;
            this.newLocation.y = this.originalLocation.y;
            this.newSize.width = this.originalSize.width;
            this.newSize.height = this.originalSize.height;
            this.element.style.display = "block";
            this.element.addEventListener("keydown", this.onKeyDown);
            this.refresh();
            for (const item of items) {
                item.properties.addEventListener("change", this.onItemPropertyChange);
            }
            this.element.focus();
        }
        onItemPropertyChange(e) {
            const properties = ["width", "height", "x", "y"];
            const changedProperties = e.changes.filter((x) => properties.includes(x.property));
            if (changedProperties.length > 0) {
                this.show(this.attachedTo);
            }
        }
        hide() {
            this.element.removeEventListener("keydown", this.onKeyDown);
            if (this.attachedTo.length > 0) {
                for (const item of this.attachedTo) {
                    item.properties.removeEventListener("change", this.onItemPropertyChange);
                }
            }
            this.attachedTo = [];
            this.element.style.display = "none";
        }
        applyInfoToElement() {
            const diffX = this.newLocation.x - this.originalLocation.x;
            const diffY = this.newLocation.y - this.originalLocation.y;
            const diffWidth = this.newSize.width - this.originalSize.width;
            const diffHeight = this.newSize.height - this.originalSize.height;
            for (const item of this.attachedTo) {
                item.properties.beginUpdate();
                item.properties.x = item.properties.x + diffX;
                item.properties.y = item.properties.y + diffY;
                item.properties.width = item.properties.width + diffWidth;
                if (item.fixedHeight === undefined || item.fixedHeight == false) {
                    item.properties.height = item.properties.height + diffHeight;
                }
                item.properties.endUpdate();
            }
            this.show(this.attachedTo);
        }
        addEventListener(event, listener) {
            switch (event) {
                case "contextmenu":
                    this.element.addEventListener("contextmenu", (e) => {
                        if (!this.attachedTo)
                            return;
                        const args = {
                            items: this.attachedTo,
                            width: "150px",
                            buttons: [],
                            onClick: () => { },
                        };
                        listener(args);
                        if (args.buttons.length === 0)
                            return;
                        e.preventDefault();
                        new ContextMenu({
                            width: args.width,
                            buttons: args.buttons,
                            top: e.clientY,
                            left: e.clientX,
                            onClick: args.onClick,
                        });
                    });
                    break;
            }
        }
    }

    function getSubsectionDataList(items, sections) {
        if (!items)
            return [];
        const subsectionDataList = items.filter((x) => x.children && x.children.length > 0);
        const existingFields = sections.map((x) => x.properties.binding);
        return subsectionDataList.filter((x) => !existingFields.includes(x.field));
    }
    function getReportSectionBindings(section) {
        const result = [];
        let iterator = section;
        while (iterator) {
            result.push(iterator.properties.binding);
            iterator = iterator.parent;
        }
        return result;
    }
    function findItemsByRect(items, rect) {
        const selected = [];
        for (const item of items) {
            if (isItemInRect(rect, item)) {
                selected.push(item);
            }
        }
        return selected;
    }
    function isItemInRect(rect, item) {
        if (!isPointInRect(rect, { x: item.properties.x, y: item.properties.y }))
            return false;
        const br = {
            x: item.properties.x + item.properties.width,
            y: item.properties.y + item.properties.height,
        };
        if (!isPointInRect(rect, br))
            return false;
        return true;
    }
    function isPointInRect(rect, point) {
        return (rect.x < point.x &&
            point.x < rect.x + rect.width &&
            rect.y < point.y &&
            point.y < rect.y + rect.height);
    }

    const DEFAULT_SECTION_HEIGHT = 50;
    const MIN_SECTION_HEIGHT = 1;
    class ReportSectionProperties extends StyleProperties {
        constructor(options) {
            super(...arguments);
            this._height = DEFAULT_SECTION_HEIGHT;
            this._binding = "";
            this._title = "Section";
            this.typeSection = options.typeSection ?? "";
            this.typeReport = options.typeReport ?? "";
            this.typesSections = options.typesSections ?? [];
        }
        get height() {
            return this._height;
        }
        get binding() {
            return this._binding;
        }
        get title() {
            return this._title;
        }
        get typeSection() {
            return this._typeSection;
        }
        get typeReport() {
            return this._typeReport;
        }
        get typesSections() {
            return this._typesSections;
        }
        get index() {
            return this._index;
        }
        set height(value) {
            const oldValue = this.height;
            this._height = Math.max(MIN_SECTION_HEIGHT, value);
            this.emitOnChange("height", value, oldValue);
        }
        set binding(value) {
            const oldValue = this.binding;
            this._binding = value;
            this.emitOnChange("binding", value, oldValue);
        }
        set title(value) {
            const oldValue = this.title;
            this._title = value;
            this.emitOnChange("title", value, oldValue);
        }
        set typesSections(value) {
            this._typesSections = value;
        }
        set typeSection(value) {
            const oldValue = this.typeSection;
            this._typeSection = value;
            this.emitOnChange("typeSection", value, oldValue);


            if (['LIGNE_EXTRAS', 'REGLEMENT_EXTRAS'].lastIndexOf(this._typeSection) > -1) {
                let extraOptions = [];
                if (this._typeSection == "LIGNE_EXTRAS") {
                    extraOptions = [
                        { value: "", label: "" },
                        { value: "LIGNES", label: "LIGNES" },
                    ];
                } else if (this._typeSection == "REGLEMENT_EXTRAS") {
                    extraOptions = [
                        { value: "", label: "" },
                        { value: "REGLEMENTS", label: "REGLEMENTS" },
                    ];
                }
                const extrasProperties = [{
                    field: "SECTION_PARENT",
                    label: "Section parent",
                    type: "string",
                    editor: createDropdownList(extraOptions)
                }];
                this.extraProperties = extrasProperties;
            }
        }
        set typeReport(value) {
            const oldValue = this.typeReport;
            this._typeReport = value;
            this.emitOnChange("typeReport", value, oldValue);
        }
        set index(value) {
            const oldValue = this.index;
            this._index = value;
            this.emitOnChange("index", value, oldValue);
        }
        getPropertyDefinitions(options) {
            return [
                //{ field: "index", label: "Index", type: "number" },
                { field: "height", label: "Height", type: "number" },
                //{ field: "title", label: "Titre", type: "string" },
                { field: "typeSection", label: "Type section", type: "string", editor: createTypeSectionDropdownEditor({ typeReport: this._typeReport, typesSections: this._typesSections }), },
                //{ field: "typeSection", label: "Type section", type: "string", editor: createTypeSectionDropdownEditor(this._typeReport), },
                ...super.getPropertyDefinitions(options),
            ];
        }
    }

    class AreaSelector {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this._selectEventEmitter = new EventEmitter();
            this._x = 0;
            this._y = 0;
            this._startX = 0;
            this._startY = 0;
            this._endX = 0;
            this._endY = 0;
            this._onMouseDown = this._onMouseDown.bind(this);
            this._onMouseMove = this._onMouseMove.bind(this);
            this._onMouseUp = this._onMouseUp.bind(this);
            this._init();
        }
        _init() {
            this.element.classList.add("anka-area-selector");
            this.options.area.appendChild(this.element);
            this.element.style.display = "none";
            this.options.area.addEventListener("mousedown", this._onMouseDown);
        }
        _getRect() {
            let x = this._x;
            let y = this._y;
            let width = this._endX - this._startX;
            let height = this._endY - this._startY;
            if (width < 0) {
                x += width;
                width = width * -1;
            }
            if (height < 0) {
                y += height;
                height = height * -1;
            }
            return { x, y, width, height };
        }
        addEventListener(event, listener) {
            if (event === "select") {
                this._selectEventEmitter.add(listener);
            }
        }
        refresh() {
            const rect = this._getRect();
            this.element.style.left = rect.x + "px";
            this.element.style.top = rect.y + "px";
            this.element.style.width = rect.width + "px";
            this.element.style.height = rect.height + "px";
        }
        _onMouseDown(e) {
            if (e.target !== this.options.area)
                return;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this._startX = e.x;
            this._startY = e.y;
            this._endX = e.x;
            this._endY = e.y;
            this.options.area.addEventListener("mousemove", this._onMouseMove);
            document.body.addEventListener("mouseup", this._onMouseUp);
            this.element.style.display = "";
            this.refresh();
        }
        _onMouseMove(e) {
            this._endX = e.x;
            this._endY = e.y;
            this.refresh();
        }
        _onMouseUp() {
            this.options.area.removeEventListener("mousemove", this._onMouseMove);
            document.body.removeEventListener("mouseup", this._onMouseUp);
            this.element.style.display = "none";
            this._selectEventEmitter.emit(this._getRect());
        }
    }

    class ReportSection {
        constructor(options) {
            this.element = document.createElement("div");
            this.elementHeader = document.createElement("div");
            this.elementContent = document.createElement("div");
            this.reportItemSelector = new ReportItemSelector(this);
            this.areaSelector = new AreaSelector({
                area: this.elementContent,
            });
            this.resizer = new Resizer({
                orientation: ResizerOrientation.Horizontal,
                onResize: (e) => {
                    this.properties.height = this.properties.height + e.offsetY;
                },
            });
            this.items = [];
            this.subsections = [];
            this.properties = new ReportSectionProperties({
                typeSection: options.typeSection,
                typeReport: options.typeReport,
                typesSections: options.typesSections,
                conditionsVisibility: options.conditionsVisibility
            });
            if (!!options.extraProperties) {
                const extraPropertyConditionVisibilityIdx = options.extraProperties.findIndex(p => p.field == 'CONDITIONS_VISIBILITY');
                if (extraPropertyConditionVisibilityIdx > -1) {
                    options.extraProperties.splice(extraPropertyConditionVisibilityIdx, 1);
                }
                this.properties.extraProperties = options.extraProperties;
                for (var p in options.extraProperties) {
                    this.properties[options.extraProperties[p].field] = options.extraProperties[p].value;
                }
            }
            this._changeEventEmitter = new EventEmitter();
            this._selectEventEmitter = new EventEmitter();
            if (options.appendTo) {
                options.appendTo.appendChild(this.element);
            }
            if (options.insertBefore) {
                options.insertBefore.parentElement.insertBefore(this.element, options.insertBefore);
            }
            this.properties.binding = options.binding || "";
            this.properties.title = options.title;
            this.properties.typeSection = options.typeSection || "";
            this.properties.typeReport = options.typeReport;
            this.properties.conditionsVisibility = options.conditionsVisibility;
            this.properties.index = options.index;
            this._designer = options.designer;
            this.parent = options.parent;
            this.styles = new MultipleStyles(...options.parentStyles, this.properties);
            this._init(options.defaultProperties);
        }
        _init(defaultProperties) {
            this.element.classList.add("anka-report-section");
            this.elementHeader.classList.add("anka-report-section__header");
            this.elementContent.classList.add("anka-report-section__content");
            this.element.tabIndex = 0;
            this.element.appendChild(this.elementHeader);
            this.element.appendChild(this.elementContent);
            this.elementContent.appendChild(this.reportItemSelector.element);
            this.elementContent.appendChild(this.resizer.element);
            if (defaultProperties) {
                this.loadLayout(defaultProperties);
            }
            this.refresh();
            this.element.addEventListener("focus", () => {
                this._onSelect({
                    type: "ReportSection",
                    element: this,
                });
            });
            this.properties.addEventListener("change", (e) => {
                this.refresh();
                this._onChange({
                    type: "change-section",
                    section: this,
                    changes: e.changes,
                });
            });
            this.elementContent.ondragover = (e) => e.preventDefault();
            this.elementContent.ondrop = (e) => this._onContentDrop(e);
            this.areaSelector.addEventListener("select", (e) => {
                const items = findItemsByRect(this.items, e);
                this.selectItem(items);
            });
            this.element.addEventListener("contextmenu", (e) => {
                /*if (!this.properties.binding)
                    return;*/
                if (e.target !== this.elementContent && e.target !== this.elementHeader) {
                    return;
                }
                const dataSource = this._designer.getDataSource();
                const bindings = getReportSectionBindings(this);
                let sectionDataSource = dataSource;
                for (let i = bindings.length - 1; i >= 0; i--) {
                    const field = bindings[i];
                    const dataSourceItem = !!sectionDataSource ? sectionDataSource.find((x) => x.field === field) : null;
                    // TODO: Possible null value here
                    sectionDataSource = dataSourceItem === null || dataSourceItem === void 0 ? void 0 : dataSourceItem.children;
                }
                const subsectionDataList = getSubsectionDataList(sectionDataSource, this.subsections);
                const buttons = subsectionDataList.map((x) => ({
                    key: "add-section",
                    label: `Add Section (${x.label})`,
                    data: x,
                }));
                buttons.push({
                    key: "paste-items",
                    label: "Coller",
                    data: this,
                });
                if (this.parent) {
                    buttons.push({
                        key: "remove-section",
                        label: "Supprimer la section",
                        data: this,
                    });
                    buttons.push({
                        key: "move-section-up",
                        label: "Déplacer vers le haut",
                        data: this,
                    });
                    buttons.push({
                        key: "move-section-down",
                        label: "Déplacer vers le bas",
                        data: this,
                    });
                }
                if (buttons.length === 0)
                    return;
                e.preventDefault();
                new ContextMenu({
                    width: "150px",
                    buttons,
                    top: e.clientY,
                    left: e.clientX,
                    onClick: (e) => {
                        switch (e.key) {
                            case "paste-items":
                                if (!!this.parent) {
                                    this.parent.pasteClipboardItems(this);
                                }
                                break;
                            case "remove-section":
                                this.parent.removeSection(this);
                                break;
                            case "move-section-up":
                                this.parent.moveSection(this, 'up');
                                break;
                            case "move-section-down":
                                this.parent.moveSection(this, 'down');
                                break;
                            case "add-section":
                                const data = e.data;
                                this.createSection({ binding: data.field });
                                break;
                        }
                    },
                });
            });
            this.reportItemSelector.addEventListener("contextmenu", (e) => {
                e.buttons = [
                    { key: "move-back", label: "Mettre en arrière" },
                    { key: "duplicate", label: "Dupliquer" },
                    { key: "copy", label: "Copier" },
                    { key: "remove", label: "Supprimer" }
                ];
                e.onClick = (args) => {
                    if (args.key === "move-back") { this.moveToBack(); }
                    if (args.key === "duplicate") { this.duplicateSelectedItem(); }
                    if (args.key === "copy") { this.copySelectedItem(); }
                    if (args.key === "remove") { this.removeSelectedItem(); }
                };
            });
        }
        refresh() {
            this.elementHeader.innerHTML = '';

            let countConditions = 0;
            if (this.properties.conditionsVisibility) {
                const countResult = AnkaConditionGroupProperty.countConditionsVisibility(this.properties.conditionsVisibility);
                countConditions = countResult.conditions;
            }

            const sectionId = this.properties.extraProperties?.find(p => p.field == 'ID');
            if (!!sectionId) {
                const bgColors = {
                    'HEADER': '#6d6d6d',
                    'CONTENT': '#6d6d6d',
                    'FOOTER': '#6d6d6d'
                };
                if (!!bgColors[sectionId.value]) {
                    this.elementHeader.style.backgroundColor = bgColors[sectionId.value];
                    this.elementHeader.style.color = '#FFF';
                }
            } else {
                const divAction = document.createElement('div');
                divAction.classList.add("anka-section-actions");

                const moveUpButton = document.createElement('button');
                moveUpButton.classList.add("anka-section-actions-button");
                const moveUpIcon = document.createElement('img');
                moveUpIcon.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAoUlEQVR4nO3XsQrCMBDG8X+FCh07XKGL4OP4AD630E3o0LGDczpGhEyhwWqTE+E+uC3wI8cdJPCnqbTBDrgBd+CkhQowAD7UBJy1Ua+BSwItissbtAguG9GsuHyIZsGrsDL+y3qtWv0r+Ljn1m1USwLqo3MHMscl4CY3FMdgb60uFWdTje1xoTgbLpSGa1xp9UPjcX8B5gi9opg2lPo3Zleemhu67izn18sAAAAASUVORK5CYII=");
                moveUpButton.appendChild(moveUpIcon);
                moveUpButton.addEventListener("click", (e) => { this.moveSection(this, 'up'); });
                divAction.appendChild(moveUpButton);

                const moveDownButton = document.createElement('button');
                moveDownButton.classList.add("anka-section-actions-button");
                const moveDownIcon = document.createElement('img');
                moveDownIcon.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAmklEQVR4nO3VzwoBUQCF8d9jsJCNUlLKSllZynN7AxuFZEiyoDzASM1oFsb8MQsxX526q+90T7cu/8IMe4RRAkyrLAgS8ji7KgvClNQFT+qJMgnrV/RbE23eCMOMrPMUjHEtIb9hkvcWQ5wLyC8YFZ2qh0MO+QkDJemm/AVxjuj7kDZWL+RbdFREE4uEfIlWVfKYBuZRHufv4A5hy5Pfj/IFnAAAAABJRU5ErkJggg==");
                moveDownButton.appendChild(moveDownIcon);
                moveDownButton.addEventListener("click", (e) => { this.moveSection(this, 'down'); });
                divAction.appendChild(moveDownButton);

                this.elementHeader.appendChild(divAction);
            }

            const newSpan = document.createElement('span');
            newSpan.innerText = this._getHeaderText();
            this.elementHeader.prepend(newSpan);

            // Créer un élément DOM pour afficher le nombre de conditions sous forme de badge
            if (countConditions > 0) {
                const badge = document.createElement('div');
                badge.classList.add('condition-badge');
                badge.title = `${countConditions} condition(s) de visibilité`;
                badge.innerText = countConditions;

                // Préceder le texte du badge avec une icone d'oeil en img svg
                const eyeIcon = document.createElement('img');
                eyeIcon.setAttribute("src", "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNSAxMEEyMC43IDIwLjcgMCAwIDEgMTUgMSAyMC43IDIwLjcgMCAwIDEgMjUgMTAgMjAuNyAyMC43IDAgMCAxIDE1IDE5QTIwLjcgMjAuNyAwIDAgMSA1IDEwWiIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8Y2lyY2xlIGN4PSIxNSIgY3k9IjEwIiByPSIzIiBmaWxsPSIjMDAwIi8+Cjwvc3ZnPg==");
                badge.prepend(eyeIcon);

                this.elementHeader.appendChild(badge);
            }

            this.elementContent.style.height = `${this.properties.height}px`;
        }
        addEventListener(event, listener) {
            switch (event) {
                case "select":
                    const callbackSelect = listener;
                    this._selectEventEmitter.add(callbackSelect);
                    break;
                case "change":
                    const callbackOnChange = listener;
                    this._changeEventEmitter.add(callbackOnChange);
                    break;
            }
        }

        

        prependItem(defaultProperties) {
            let extraProperties = null;
            if (!!defaultProperties.extraProperties) {
                if (typeof defaultProperties.extraProperties === "string") {
                    defaultProperties.extraProperties = JSON.parse(defaultProperties.extraProperties);
                }
                extraProperties = defaultProperties.extraProperties;
            }
            if (extraProperties == null) { extraProperties = []; }
            for (var p in extraProperties) {
                extraProperties[p].IS_EXTRA_PROPERTY = true;
            }

            const item = new DesignerReportItem({
                parentStyles: this.styles.getList(),
                defaultProperties,
                prependTo: this.elementContent,
                extraProperties: extraProperties,
                type: defaultProperties.type,
                fixedWidth: defaultProperties.fixedWidth,
                fixedHeight: defaultProperties.fixedHeight,
                hiddenProperties: defaultProperties.hiddenProperties,
            });
            item.addEventListener("change", (e) => {
                this._onChange({ type: "change-item", item, changes: e.changes });
            });
            item.addEventListener("focus", () => this.selectItem([item]));
            this.items.unshift(item);
            this._onChange({ type: "add-item", item });
            return item;
        }
        createItem(defaultProperties) {
            let extraProperties = null;
            if (!!defaultProperties.extraProperties) {
                if (typeof defaultProperties.extraProperties === "string") {
                    defaultProperties.extraProperties = JSON.parse(defaultProperties.extraProperties);
                }
                extraProperties = defaultProperties.extraProperties;
            }
            if (extraProperties == null) { extraProperties = []; }
            for (var p in extraProperties) {
                extraProperties[p].IS_EXTRA_PROPERTY = true;
            }

            var item;
            if (defaultProperties.binding == 'CLU|FUNCTION|TABLE') {
                item = new TableReportItemComponent({
                    parentStyles: this.styles.getList(),
                    defaultProperties,
                    appendTo: this.elementContent,
                    extraProperties: extraProperties,
                    type: defaultProperties.type,
                    fixedWidth: defaultProperties.fixedWidth,
                    fixedHeight: defaultProperties.fixedHeight,
                    hiddenProperties: defaultProperties.hiddenProperties,
                });
                item.addEventListener("select", (e) => {
                    this.selectItem([item]);
                });
            } else {
                if (!!extraProperties) {
                    const availablesDatasourceProperties = Array.prototype.concat.apply([], this._designer.dataSourceTreeList.dataSource.filter(d => d.children).map(d => d.children.map(c => c.data)));
                    extraProperties.forEach((property, index) => {
                        if (property.type == 'select') {
                            //extraProperties[index].items = [];
                            if (property.field == 'TAX_TYPE_VALUE') {
                                const taxFunctionDatasource = availablesDatasourceProperties.find(p => p.field == 'CLU|FUNCTION|TAXE');
                                if (!!taxFunctionDatasource?.extraProperties) {
                                    const taxFunctionExtraProperty = taxFunctionDatasource.extraProperties.find(p => p.field == property.field);
                                    if (taxFunctionExtraProperty?.items) {
                                        extraProperties[index].items = taxFunctionExtraProperty.items;
                                        return;
                                    }
                                }
                            }
                        }
                    });
                }
                item = new DesignerReportItem({
                    parentStyles: this.styles.getList(),
                    defaultProperties,
                    appendTo: this.elementContent,
                    extraProperties: extraProperties,
                    type: defaultProperties.type,
                    fixedWidth: defaultProperties.fixedWidth,
                    fixedHeight: defaultProperties.fixedHeight,
                    hiddenProperties: defaultProperties.hiddenProperties,
                });
                item.addEventListener("focus", (e) => {
                    this.selectItem([item]);
                });
            }
            item.addEventListener("change", (e) => {
                this._onChange({ type: "change-item", item, changes: e.changes });
            });
            this.items.push(item);
            this._onChange({ type: "add-item", item });
            return item;
        }
        moveToBack() {
            const items = this.reportItemSelector.attachedTo;
            const item = items[0];
            const clonedItem = JSON.parse(JSON.stringify(item));
            const index = this.items.findIndex((x) => x === item);
            this.items.splice(index, 1);
            item.dispose();

            this.prependItem(clonedItem);
        }
        duplicateSelectedItem() {
            const items = this.reportItemSelector.attachedTo;
            const clonedItems = [];
            for (const item of items) {
                const newItem = JSON.parse(JSON.stringify(item));
                newItem.x += 10;
                newItem.y += 10;
                clonedItems.push(this.createItem(newItem));
            }
            this.selectItem(clonedItems);
        }
        copySelectedItem() {
            const items = this.reportItemSelector.attachedTo;
            if (!navigator.clipboard) {
                console.error('Accès au presse-papier impossible : Vérifier que le navigateur a les droits nécéssaires');
                return;
            }
            navigator.clipboard.writeText(JSON.stringify(items));
        }
        removeSelectedItem() {
            const items = this.reportItemSelector.attachedTo;
            for (const item of items) {
                this.reportItemSelector.hide();
                this.removeItem(item);
                this._onChange({ type: "remove-item", item });
            }
        }
        removeItem(item) {
            const index = this.items.findIndex((x) => x === item);
            this.items.splice(index, 1);
            item.dispose();
        }
        selectItem(items) {
            this.deselectAll();
            if (items.length === 0)
                return;

            this.reportItemSelector.show(items);
            this._onSelect({ type: "ReportItem", element: items[0] }); // Fix here
        }
        deselectAll() {
            this.reportItemSelector.hide();
            this.subsections.forEach((x) => x.deselectAll());
        }
        moveSection(section, dir) {
            //if (section.parent.subsections.length > 0) {
            const index = section.parent.subsections.findIndex((x) => x === section);
            if (index > -1) {
                if (dir == "up") {
                    if (!!section.parent.subsections[index - 1]?.element) {
                        section.parent.subsections[index].dispose();
                        section.parent.insertSection(section.parent.subsections[index], section.parent.subsections[index - 1].element, index - 1, index);
                    } else if (!!section.parent.properties.extraProperties) {
                        const sectionId = section.parent.properties.extraProperties.find(p => p.field == 'ID');
                        if (!!sectionId) {
                            let targetSectionId = null;
                            if (sectionId.value == 'FOOTER') {
                                if (!!this._designer.reportContainer.report.reportSectionContent) {
                                    targetSectionId = 'reportSectionContent';
                                } else if (!!this._designer.reportContainer.report.reportSectionHeader) {
                                    targetSectionId = 'reportSectionHeader';
                                }
                            } else if (sectionId.value == 'CONTENT') {
                                if (!!this._designer.reportContainer.report.reportSectionHeader) {
                                    targetSectionId = 'reportSectionHeader';
                                }
                            }
                            if (!!targetSectionId && !!this._designer.reportContainer.report[targetSectionId]) {
                                section.parent.subsections[index].dispose();
                                this._designer.reportContainer.report[targetSectionId].appendSection(section.parent.subsections[index], index);
                                section.parent.subsections.splice(index, 1);
                            }
                        }
                    }
                } else if (dir == "down") {
                    if (!!section.parent.subsections[index + 1]?.element?.nextSibling) {
                        section.parent.subsections[index].dispose();
                        section.parent.insertSection(section.parent.subsections[index], section.parent.subsections[index + 1].element.nextSibling, index + 1, index);
                    } else if (index + 1 < section.parent.subsections.length) {
                        section.parent.subsections[index].dispose();
                        section.parent.appendSection(section.parent.subsections[index], index);
                        section.parent.subsections.splice(index, 1);
                    } else if (!!section.parent.properties.extraProperties) {
                        const sectionId = section.parent.properties.extraProperties.find(p => p.field == 'ID');
                        if (!!sectionId) {
                            let targetSectionId = null;
                            if (sectionId.value == 'HEADER') {
                                if (!!this._designer.reportContainer.report.reportSectionContent) {
                                    targetSectionId = 'reportSectionContent';
                                } else if (!!this._designer.reportContainer.report.reportSectionFooter) {
                                    targetSectionId = 'reportSectionFooter';
                                }
                            } else if (sectionId.value == 'CONTENT') {
                                if (!!this._designer.reportContainer.report.reportSectionFooter) {
                                    targetSectionId = 'reportSectionFooter';
                                }
                            }
                            if (!!targetSectionId && !!this._designer.reportContainer.report[targetSectionId]) {
                                if (this._designer.reportContainer.report[targetSectionId].subsections.length > 0) {
                                    section.parent.subsections[index].dispose();
                                    this._designer.reportContainer.report[targetSectionId].insertSection(section.parent.subsections[index], this._designer.reportContainer.report[targetSectionId].subsections[0].element, 0);
                                    section.parent.subsections.splice(index, 1);
                                } else {
                                    section.parent.subsections[index].dispose();
                                    this._designer.reportContainer.report[targetSectionId].appendSection(section.parent.subsections[index], index);
                                    section.parent.subsections.splice(index, 1);
                                }
                            }
                        }
                    }
                }
            }
            //}
        }
        createSection(defaultProperties) {
            const section = new ReportSection({
                title: "Content",
                binding: defaultProperties.customId || "",
                designer: this._designer,
                parent: this,
                parentStyles: this.styles.getList(),
                defaultProperties,
                appendTo: this.element,
                typeSection: defaultProperties.typeSection,
                typesSections: defaultProperties.typesSections,
                typeReport: defaultProperties.typeReport,
                index: this.subsections.length + 1,
                extraProperties: defaultProperties.extraProperties,
                conditionsVisibility: defaultProperties.conditionsVisibility,
            });
            section.addEventListener("change", (e) => this._onChange(e));
            section.addEventListener("select", (e) => this._onSelect(e));
            this.subsections.push(section);
            this._onChange({ type: "add-section", section });
            return section;
        }
        insertSection(sectionToInsert, insertBefore, newIndex, oldIndex) {
            const section = new ReportSection({
                title: sectionToInsert.properties.title,
                binding: sectionToInsert.properties.binding,
                designer: this._designer,
                parent: this,
                parentStyles: sectionToInsert.styles.styles,
                defaultProperties: sectionToInsert.properties,
                insertBefore: insertBefore,
                typeSection: sectionToInsert.properties.typeSection,
                typeReport: sectionToInsert.properties.typeReport,
                index: newIndex,
                extraProperties: sectionToInsert.properties.extraProperties,
            });
            section.addEventListener("change", (e) => this._onChange(e));
            section.addEventListener("select", (e) => this._onSelect(e));
            sectionToInsert.items.forEach(item => {
                section.createItem(item.properties);
            });
            if (oldIndex !== undefined) {
                this.subsections.splice(oldIndex, 1);
                if (newIndex > oldIndex) {
                    newIndex = newIndex - oldIndex + this.subsections.slice(0, oldIndex).length;
                }
            }
            this.subsections = [...this.subsections.slice(0, newIndex), section, ...this.subsections.slice(newIndex)];
            this._onChange({ type: "add-section", section });
            return section;
        }
        appendSection(sectionToInsert, oldIndex) {
            const section = new ReportSection({
                title: sectionToInsert.properties.title,
                binding: sectionToInsert.properties.binding,
                designer: this._designer,
                parent: this,
                parentStyles: sectionToInsert.styles.styles,
                defaultProperties: sectionToInsert.properties,
                appendTo: this.element,
                typeSection: sectionToInsert.properties.typeSection,
                typeReport: sectionToInsert.properties.typeReport,
                index: this.subsections.length + 1,
                extraProperties: sectionToInsert.properties.extraProperties,
            });
            section.addEventListener("change", (e) => this._onChange(e));
            section.addEventListener("select", (e) => this._onSelect(e));
            sectionToInsert.items.forEach(item => {
                section.createItem(item.properties);
            });
            this.subsections.push(section);
            this._onChange({ type: "add-section", section });
            return section;
        }
        removeSection(section) {
            const index = this.subsections.findIndex((x) => x === section);
            if (index < 0)
                return;
            this.subsections.splice(index, 1);
            this._onChange({ type: "remove-section", section });
            section.dispose();
        }
        pasteClipboardItems(section) {
            navigator.clipboard.readText().then((clipText) => {
                const items = JSON.parse(clipText);
                const pastedItems = [];
                for (const item of items) {
                    pastedItems.push(section.createItem(item));
                }
                section.selectItem(pastedItems);
            });
        }
        loadLayout(layout) {
            var _a, _b;
            if (layout.height)
                this.properties.height = layout.height;
            if (layout.binding)
                this.properties.binding = layout.binding;
            (_a = layout.items) === null || _a === void 0 ? void 0 : _a.forEach((data) => {
                this.createItem(data);
            });
            (_b = layout.sections) === null || _b === void 0 ? void 0 : _b.forEach((data) => {
                if (!data.typeReport) {
                    data.typeReport = this.properties._typeReport;
                }
                data.typesSections = this.properties._typesSections;
                this.createSection(data);
            });
            this.properties.beginUpdate();
            this.properties.color = layout.color;
            this.properties.backgroundColor = layout.backgroundColor;
            this.properties.textAlign = layout.textAlign;
            this.properties.textMode = layout.textMode;
            this.properties.borderWidth = layout.borderWidth;
            this.properties.borderStyle = layout.borderStyle;
            this.properties.borderColor = layout.borderColor;
            this.properties.fontFamily = layout.fontFamily;
            this.properties.fontSize = layout.fontSize;
            this.properties.fontWeight = layout.fontWeight;
            if (!!layout.typeSection) { this.properties.typeSection = layout.typeSection; }
            this.properties.endUpdate();
            this.refresh();
        }
        toJSON() {
            let result = {
                height: this.properties.height,
                binding: this.properties.binding,
                items: this.items.map((x) => x.toJSON()),
                sections: this.subsections.map((x) => x.toJSON()),
                color: this.properties.color,
                backgroundColor: this.properties.backgroundColor,
                textAlign: this.properties.textAlign,
                textMode: this.properties.textMode,
                borderWidth: this.properties.borderWidth,
                borderStyle: this.properties.borderStyle,
                borderColor: this.properties.borderColor,
                fontFamily: this.properties.fontFamily,
                fontSize: this.properties.fontSize,
                fontWeight: this.properties.fontWeight,
                typeSection: this.properties.typeSection,
                typeReport: this.properties.typeReport,
                index: this.properties.index,
                extraProperties: this.properties.extraProperties,
                conditionsVisibility: this.properties.conditionsVisibility
            };

            for (var e in this.properties.extraProperties) {
                if (!!this.properties.extraProperties[e].field && !!this.properties[this.properties.extraProperties[e].field]) {
                    this.properties.extraProperties[e]['value'] = this.properties[this.properties.extraProperties[e].field];
                }
            }

            return result;
        }
        dispose() {
            this.element.remove();
        }
        _getHeaderText() {
            let title = this.properties.title;
            if (this.properties.typeSection) {
                title += ` (${this.properties.typeSection})`;
            } else if (this.properties.binding) {
                title += ` (${this.properties.binding})`;
            }
            return title;
        }
        _onChange(args) {
            this._changeEventEmitter.emit(args);
        }
        _onContentDrop(e) {
            var _a, _b;
            e.preventDefault();
            const text = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("label");
            let extraProperties = _a.getData("extraProperties");
            const field = _a.getData("field");
            const type = _a.getData("type");
            const value = _a.getData("value");
            extraProperties = extraProperties != "undefined" ? extraProperties : undefined;

            let width = 100; let height = 20, fixedWidth = false, fixedHeight = false;
            if (field == 'CLU|FUNCTION|IMAGE') { width = 40; height = 40; extraProperties = [{ field: "IMG_SRC", label: "Source", type: "image" }]; }
            if (field == 'CLU|FUNCTION|BARCODE') { width = 100; height = 50; extraProperties = [{ field: "BARCODE_VALUE", label: "Valeur", type: "string" }]; }
            if (field == 'CLU|FUNCTION|QRCODE') { width = 40; height = 40; extraProperties = [{ field: "QR_VALUE", label: "Valeur", type: "string" }]; }
            if (field == 'CLU|FUNCTION|LINE') { width = 100; height = 1; fixedHeight = true; }
            if (field == 'CLU|FUNCTION|VLINE') { width = 1; height = 100; fixedWidth = true; }
            if (field == 'CLU|FUNCTION|RECTANGLE') { width = 75; height = 75; }
            if (field == 'CLU|FUNCTION|TABLE') { width = 300; height = 100; }

            const item = this.createItem({
                text: value != "undefined" ? value : (text || "Label"),
                binding: ((_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.getData("field")) || "",
                x: e.offsetX,
                y: e.offsetY,
                width: width,
                height: height,
                extraProperties: extraProperties,
                type: type,
                fixedWidth: fixedWidth,
                fixedHeight: fixedHeight,
            });
            this.selectItem([item]);
        }
        _onSelect(args) {
            this._selectEventEmitter.emit(args);
        }
    }

    const DEFAULT_REPORT_WIDTH = 400;
    const MIN_REPORT_WIDTH = 100;
    class ReportProperties extends StyleProperties {
        constructor() {
            super(...arguments);
            this._width = DEFAULT_REPORT_WIDTH;
        }
        get width() {
            return this._width;
        }
        set width(value) {
            const oldValue = this.width;
            this._width = Math.max(value, MIN_REPORT_WIDTH);
            this.emitOnChange("width", value, oldValue);
        }
        get layoutMode() {
            return this._layoutMode;
        }
        set layoutMode(value) {
            const oldValue = this.layoutMode;
            this._layoutMode = value;
            this.emitOnChange("layoutMode", value, oldValue);
        }
        getPropertyDefinitions(options) {
            return [
                { field: "width", label: "Width", type: "number" },
                {
                    field: "layoutMode",
                    label: "Layout Mode",
                    type: "number",
                    editor: createLayoutModesDropdownEditor(),
                },
                ...super.getPropertyDefinitions(options),
            ];
        }
    }

    class AnkaConditionGroupProperty {
        static countConditionsVisibility(query) {
            let conditionCount = 0;
            let groupCount = 0;

            function explore(node) {
                if (!node) return;
                if (node.type === "condition") {
                    conditionCount++;
                    return;
                }

                if (node.type === "group" && Array.isArray(node.conditions)) {
                    groupCount++;
                    node.conditions.forEach(subNode => explore(subNode));
                }
            }

            explore(query);

            return {
                conditions: conditionCount,
                groups: groupCount,
                total: conditionCount + groupCount
            };
        }
    }

    class Report {
        constructor(options) {
            this.element = document.createElement("div");
            this.resizer = new Resizer({
                orientation: ResizerOrientation.Vertical,
                onResize: (e) => {
                    this.properties.width = this.properties.width + e.offsetX;
                },
            });
            this.properties = new ReportProperties();
            this._changeEventEmitter = new EventEmitter();
            this.layout = options.layout;
            if (!!this.layout.headerSection) {
                this.reportSectionHeader = new ReportSection({
                    title: "Header",
                    designer: options.designer,
                    parentStyles: [this.properties],
                    appendTo: this.element,
                    extraProperties: [{ field: 'ID', value: 'HEADER' }],
                    typeReport: options.typeReport,
                    typesSections: options.typesSections,
                    conditionsVisibility: this.layout.headerSection.conditionsVisibility
                });
            }
            if (!!this.layout.contentSection) {
                this.reportSectionContent = new ReportSection({
                    title: "Content",
                    designer: options.designer,
                    parentStyles: [this.properties],
                    appendTo: this.element,
                    extraProperties: [{ field: 'ID', value: 'CONTENT' }],
                    typeReport: options.typeReport,
                    typesSections: options.typesSections,
                    conditionsVisibility: this.layout.contentSection.conditionsVisibility
                });
            }
            if (!!this.layout.footerSection) {
                this.reportSectionFooter = new ReportSection({
                    title: "Footer",
                    designer: options.designer,
                    parentStyles: [this.properties],
                    appendTo: this.element,
                    extraProperties: [{ field: 'ID', value: 'FOOTER' }],
                    typeReport: options.typeReport,
                    typesSections: options.typesSections,
                    conditionsVisibility: this.layout.footerSection.conditionsVisibility
                });
            }
            this._init();
        }
        _init() {
            this.element.classList.add("anka-report");
            this.element.tabIndex = 0;
            this.element.appendChild(this.resizer.element);
            this.properties.addEventListener("change", (e) => {
                this.refresh();
                this._onChange({
                    type: "change-report",
                    report: this,
                    changes: e.changes,
                });
            });
            this._initChangeEvents();
            this._initKeyDownEvents();
            this._initSelectEvents();
            this.refresh();
        }
        _initChangeEvents() {
            if (!!this.layout.headerSection) {
                this.reportSectionHeader.addEventListener("change", (e) => {
                    this._onChange(e);
                });
            }
            if (!!this.layout.contentSection) {
                this.reportSectionContent.addEventListener("change", (e) => {
                    this._onChange(e);
                });
            }
            if (!!this.layout.footerSection) {
                this.reportSectionFooter.addEventListener("change", (e) => {
                    this._onChange(e);
                });
            }
        }
        _initKeyDownEvents() {
            this.element.addEventListener("keydown", (e) => {
                if (e.key === "Delete") {
                    if (!!this.layout.headerSection) {
                        this.reportSectionHeader.removeSelectedItem();
                    }
                    if (!!this.layout.contentSection) {
                        this.reportSectionContent.removeSelectedItem();
                    }
                    if (!!this.layout.footerSection) {
                        this.reportSectionFooter.removeSelectedItem();
                    }
                }
            });
        }
        _initSelectEvents() {
            if (!!this.layout.headerSection) {
                this.reportSectionHeader.addEventListener("select", (e) => {
                    this._deselectExcept(e, this.reportSectionHeader);
                });
            }
            if (!!this.layout.contentSection) {
                this.reportSectionContent.addEventListener("select", (e) => {
                    this._deselectExcept(e, this.reportSectionContent);
                });
            }
            if (!!this.layout.footerSection) {
                this.reportSectionFooter.addEventListener("select", (e) => {
                    this._deselectExcept(e, this.reportSectionFooter);
                });
            }
        }
        _deselectExcept(e, exceptReportSection) {
            if (!!this.layout.headerSection) {
                if (e.type !== "ReportItem" ||
                    exceptReportSection !== this.reportSectionHeader) {
                    this.reportSectionHeader.deselectAll();
                }
            }
            if (!!this.layout.contentSection) {
                if (e.type !== "ReportItem" ||
                    exceptReportSection !== this.reportSectionContent) {
                    this.reportSectionContent.deselectAll();
                }
            }
            if (!!this.layout.footerSection) {
                if (e.type !== "ReportItem" ||
                    exceptReportSection !== this.reportSectionFooter) {
                    this.reportSectionFooter.deselectAll();
                }
            }
        }
        refresh() {
            this.element.style.width = `${this.properties.width}px`;
        }
        addEventListener(event, listener) {
            switch (event) {
                case "select":
                    if (!!this.layout.headerSection) {
                        this.reportSectionHeader.addEventListener(event, listener);
                    }
                    if (!!this.layout.contentSection) {
                        this.reportSectionContent.addEventListener(event, listener);
                    }
                    if (!!this.layout.footerSection) {
                        this.reportSectionFooter.addEventListener(event, listener);
                    }
                    break;
                case "change":
                    const callbackOnChange = listener;
                    this._changeEventEmitter.add(callbackOnChange);
                    break;
            }
        }
        loadLayout(layout) {
            this.properties.width = layout.width;
            this.properties.layoutMode = layout.layoutMode;
            this.properties.color = layout.color;
            this.properties.backgroundColor = layout.backgroundColor;
            this.properties.textAlign = layout.textAlign;
            this.properties.textMode = layout.textMode;
            this.properties.borderWidth = layout.borderWidth;
            this.properties.borderStyle = layout.borderStyle;
            this.properties.borderColor = layout.borderColor;
            this.properties.fontFamily = layout.fontFamily;
            this.properties.fontSize = layout.fontSize;
            this.properties.fontWeight = layout.fontWeight;
            if (!!layout.headerSection) { this.reportSectionHeader.loadLayout(layout.headerSection); }
            if (!!layout.contentSection) { this.reportSectionContent.loadLayout(layout.contentSection); }
            if (!!layout.footerSection) { this.reportSectionFooter.loadLayout(layout.footerSection); }
            this.refresh();
        }
        toJSON() {
            return {
                width: this.properties.width,
                layoutMode: this.properties.layoutMode,
                color: this.properties.color,
                backgroundColor: this.properties.backgroundColor,
                textAlign: this.properties.textAlign,
                textMode: this.properties.textMode,
                borderWidth: this.properties.borderWidth,
                borderStyle: this.properties.borderStyle,
                borderColor: this.properties.borderColor,
                fontFamily: this.properties.fontFamily,
                fontSize: this.properties.fontSize,
                fontWeight: this.properties.fontWeight,
                headerSection: !!this.reportSectionHeader ? this.reportSectionHeader.toJSON() : null,
                contentSection: !!this.reportSectionContent ? this.reportSectionContent.toJSON() : null,
                footerSection: !!this.reportSectionFooter ? this.reportSectionFooter.toJSON() : null,
            };
        }
        _onChange(args) {
            this._changeEventEmitter.emit(args);
        }
    }

    class ReportContainer {
        constructor(options) {
            this.element = document.createElement("div");
            this._changeEventEmitter = new EventEmitter();
            this.report = new Report({ designer: options.designer, layout: options.layout, typeReport: options.typeReport, typesSections: options.typesSections });
            this._init();
        }
        _init() {
            this.element.classList.add("anka-report-container");
            this.element.appendChild(this.report.element);
            this.report.addEventListener("change", (e) => this._onChange(e));
        }
        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    const callbackOnChange = listener;
                    this._changeEventEmitter.add(callbackOnChange);
                    break;
                case "select":
                    const callbackOnSelect = listener;
                    this.report.addEventListener("select", callbackOnSelect);
                    this.element.addEventListener("click", (e) => {
                        if (e.target === this.element) {
                            e.preventDefault();
                            callbackOnSelect({ type: "Report", element: this.report });
                        }
                    });
                    break;
            }
        }
        loadLayout(layout) {
            return this.report.loadLayout(layout);
        }
        toJSON() {
            return this.report.toJSON();
        }
        _onChange(args) {
            this._changeEventEmitter.emit(args);
        }
    }

    class Panel {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.elementHeader = document.createElement("div");
            this.elementHeaderImage = document.createElement("img");
            this.elementHeaderText = document.createElement("span");
            this.elementContentContainer = document.createElement("div");
            this.elementContent = document.createElement("div");
            this.init();
        }
        init() {
            this.element.classList.add("anka-panel");
            this.elementHeader.classList.add("anka-panel__header");
            this.elementContentContainer.classList.add("anka-panel__content-container");
            this.elementContent.classList.add("anka-panel__content");
            this.element.appendChild(this.elementHeader);
            this.element.appendChild(this.elementContentContainer);
            this.elementHeader.appendChild(this.elementHeaderImage);
            this.elementHeader.appendChild(this.elementHeaderText);
            this.elementContentContainer.appendChild(this.elementContent);
            this.refresh();
        }
        refresh() {
            if (this.options.icon) {
                this.elementHeaderImage.src = this.options.icon || "";
                this.elementHeaderImage.style.paddingRight = "5px";
                this.elementHeaderImage.style.display = "";
            }
            else {
                this.elementHeaderImage.style.display = "none";
            }
            this.elementHeaderText.innerText = this.options.title;
        }
        appendChild(child) {
            this.elementContent.appendChild(child);
        }
    }

    class Tab {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.elementIcon = document.createElement("img");
            this.elementText = document.createElement("span");
            this._init();
        }
        get content() {
            return this.options.content;
        }
        _init() {
            this.element.classList.add("anka-tab");
            this.elementIcon.classList.add("anka-tab__icon");
            this.elementText.classList.add("anka-tab__text");
            this.element.appendChild(this.elementIcon);
            this.element.appendChild(this.elementText);
            this.elementText.innerText = this.options.title;
        }
        select() {
            this.element.classList.add("selected");
        }
        unselect() {
            this.element.classList.remove("selected");
        }
        addEventListener(event, listener) {
            if (event === "click") {
                this.element.addEventListener("click", () => {
                    listener(this.options.content);
                });
            }
        }
    }

    class Tabs {
        constructor(options) {
            this.options = options;
            this.element = document.createElement("div");
            this.elementHeader = document.createElement("div");
            this.elementContentContainer = document.createElement("div");
            this.elementContent = document.createElement("div");
            this.tabs = [];
            this._init();
        }
        _init() {
            this.element.classList.add("anka-tabs");
            this.elementHeader.classList.add("anka-tabs__header");
            this.elementContentContainer.classList.add("anka-tabs__content-container");
            this.elementContent.classList.add("anka-tabs__content");
            this.element.appendChild(this.elementHeader);
            this.element.appendChild(this.elementContentContainer);
            this.elementContentContainer.appendChild(this.elementContent);
            this.options.tabs.forEach((tabOptions) => {
                const tab = new Tab(tabOptions);
                tab.addEventListener("click", () => {
                    this.selectTab(tab);
                });
                this.tabs.push(tab);
                this.elementHeader.appendChild(tab.element);
            });
            if (this.tabs.length > 0) {
                this.selectTab(this.tabs[0]);
            }
        }
        selectTab(tab) {
            var _a;
            (_a = this.selectedTab) === null || _a === void 0 ? void 0 : _a.unselect();
            this.selectedTab = tab;
            tab.select();
            this.elementContent.innerHTML = "";
            this.elementContent.appendChild(tab.content);
        }
    }

    class SearchTextbox {
        constructor() {
            this.element = document.createElement("div");
            this.inputText = document.createElement("input");
            this.inputText.placeholder = 'Rechercher';
            this._changeEventEmitter = new EventEmitter();
            //this._width = 300;
            this.init();
        }
        get width() {
            return this._width;
        }
        set width(value) {
            this._width = value;
            this.refresh();
        }
        init() {
            this.element.classList.add("anka-searchtextbox");
            this.inputText.classList.add("anka-searchtextbox__input");
            this.inputText.addEventListener('change', (e) => {
                this._changeEventEmitter.emit(e.target.value);
            });
            this.element.appendChild(this.inputText);
            this.refresh();
        }
        refresh() {
            //this.element.style.width = this._width + "px";
        }

        addEventListener(event, listener) {
            switch (event) {
                case "change":
                    this.inputText.addEventListener("keyup", (event) => {
                        if (event.keyCode === 13) {
                            listener(event.target.value);
                        }
                    });
                    break;
            }
        }
    }

    class Sidebar {
        constructor() {
            this.element = document.createElement("div");
            this.elementContent = document.createElement("div");
            this.searchtext = new SearchTextbox();
            this._width = 270;
            this.init();
        }
        get width() {
            return this._width;
        }
        set width(value) {
            this._width = value;
            this.refresh();
        }
        init() {
            this.element.classList.add("anka-sidebar");
            this.elementContent.classList.add("anka-sidebar__content");
            this.elementContent.appendChild(this.searchtext.element);
            this.element.appendChild(this.elementContent);
            this.refresh();
        }
        refresh() {
            this.element.style.width = this._width + "px";
        }
        addPanel(icon, title, content) {
            const panel = new Panel({ icon, title });
            panel.elementContent.appendChild(content);
            this.elementContent.appendChild(panel.element);
        }
        addTabs(tabOptions) {
            const tabs = new Tabs({ tabs: tabOptions });
            this.elementContent.appendChild(tabs.element);
        }
    }

    class ToolbarButton {
        constructor(options) {
            this.element = document.createElement("div");
            if (!!options.id) { this.element.id = options.id; }
            this.elementIcon = document.createElement("img");
            this.elementIcon.style.maxHeight = '100%';
            this.elementText = document.createElement("span");
            this._text = "";
            this._title = "";
            this._draggable = false;
            this._disabled = false;
            this.element.classList.add("anka-toolbar-button");
            this.element.appendChild(this.elementIcon);
            this.element.appendChild(this.elementText);
            this._icon = options.icon;
            this._text = options.text;
            this._title = options.title;
            this.element.style.width = (!!options.width ? options.width : 25) + "px";
            this.element.style.height = 25 + "px";
            if (options.draggable) {
                this._draggable = options.draggable;
            }
            if (options.onclick) {
                this.onclick = options.onclick;
            }
            this._hidden = options.hidden;
            this._styles = options.styles;
            this.refresh();
        }
        get text() {
            return this._text;
        }
        set text(value) {
            this._text = value;
        }
        get title() {
            return this._title;
        }
        set title(value) {
            this._title = value;
        }
        get draggable() {
            return this._draggable;
        }
        set draggable(value) {
            this._draggable = value;
        }
        get hidden() {
            return this._hidden;
        }
        set hidden(value) {
            this._hidden = value;
        }
        get styles() {
            return this._styles;
        }
        set styles(value) {
            this._styles = value;
        }
        get disabled() {
            return this._disabled;
        }
        set disabled(value) {
            this._disabled = value;
            this.refresh();
        }
        refresh() {
            this.element.title = this._title;
            this.element.draggable = this._draggable;
            this.elementIcon.src = this._icon || "";
            this.elementText.innerText = this._text;
            if (this._disabled) {
                this.element.style.backgroundColor = "transparent";
                this.element.style.cursor = "not-allowed";
            }
            else {
                this.element.style.backgroundColor = "";
                this.element.style.cursor = "";
            }
            this.elementIcon.style.display = this._icon ? "" : "none";
            if (this._hidden !== undefined && this._hidden == true) {
                this.element.style.display = this._hidden == true ? "none" : "";
            }

            if (!!this._styles) {
                for (var s in this._styles) {
                    this.element.style[s] = this._styles[s];
                }
            }
        }
        addEventListener(event, callback) {
            switch (event) {
                case "click":
                    this.element.addEventListener("click", callback);
                    break;
            }
        }
    }

    var ToolbarOrientation;
    (function (ToolbarOrientation) {
        ToolbarOrientation[ToolbarOrientation["Horizontal"] = 0] = "Horizontal";
        ToolbarOrientation[ToolbarOrientation["Vertical"] = 1] = "Vertical";
    })(ToolbarOrientation || (ToolbarOrientation = {}));
    class Toolbar {
        constructor(orientation = ToolbarOrientation.Vertical) {
            this.orientation = orientation;
            this.element = document.createElement("div");
            this.buttons = [];
            this.element.classList.add("anka-toolbar");
            switch (orientation) {
                case ToolbarOrientation.Vertical:
                    this.element.classList.add("anka-toolbar-vertical");
                    break;
                case ToolbarOrientation.Horizontal:
                    this.element.classList.add("anka-toolbar-horizontal");
                    break;
            }
        }
        addButton(options) {
            const button = new ToolbarButton(options);
            button.element.addEventListener("dragstart", (e) => {
                e.dataTransfer.clearData();
                if (!!options.field) { e.dataTransfer.setData("field", options.field); }
                if (!!options.label) { e.dataTransfer.setData("label", options.label); }
            });
            this.element.appendChild(button.element);
            this.buttons.push(button);
            return button;
        }
        updateButton(id, options) {
            const button = document.getElementById(id);
            if (!!options.styles) {
                Object.keys(options.styles).forEach(function (styleId) {
                    button.style[styleId] = options.styles[styleId];
                });
            }
            if (!!options.text) { button.textContent = options.text; }
        }
    }

    class ToolbarLeftMenu extends Toolbar {
        constructor() {
            super(ToolbarOrientation.Vertical);
            this.labelButton = this.addButton({
                text: "Ͳ",
                title: "Label",
                draggable: true,
            });
            this.lineButton = this.addButton({
                field: 'CLU|FUNCTION|LINE',
                text: "",
                title: "Line",
                icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nO3RQQ0AAAgCQPuX1gAGcOrdxh9GBAAAAABP5dI004UMOfsIAAAAAOcVg2G3SeBKR5YAAAAASUVORK5CYII=',
                draggable: true,
            });
            this.lineButton = this.addButton({
                field: 'CLU|FUNCTION|VLINE',
                text: "",
                title: "Vertical Line",
                icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nGNgGGngPxSPWoAT/B8NIkLg/2gQEQL/R4OIEPg/GkSEwP/RIBr+QTT4AAACDyfZW+A7mgAAAABJRU5ErkJggg==',
                draggable: true,
            });
            this.lineButton = this.addButton({
                field: 'CLU|FUNCTION|RECTANGLE',
                text: "",
                title: "Rectangle",
                icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAfklEQVR4nO2TsQ2AMBDEvP9ahLmOhirQREI6QLb0/b+dgIiIyDPsQD424+6QfHQutBfyEIvQf07xj9A3H4vQtx2L0Dcci5y0zVpkpm3WIhbhXXOhvZCHWIT+c4p/hL75WIS+7ViEvuFY5KRt1iIzvykyXrBUFme7O0RERIRFDrj0FVPwmKNpAAAAAElFTkSuQmCC',
                draggable: true,
            });
            this.imageButton = this.addButton({
                field: 'CLU|FUNCTION|IMAGE',
                text: "",
                title: "Image",
                icon: icon_image_placeholder,
                draggable: true,
            });
            this.barcodeButton = this.addButton({
                field: 'CLU|FUNCTION|BARCODE',
                text: "",
                title: "Codes barres",
                icon: icon_barcode_placeholder,
                draggable: true,
            });
            this.barcodeButton = this.addButton({
                field: 'CLU|FUNCTION|QRCODE',
                text: "",
                title: "QR Code",
                icon: icon_qrcode_placeholder,
                draggable: true,
            });
            this.addButton({
                field: 'CLU|FUNCTION|TABLE',
                text: "",
                title: "Tableau",
                icon: icon_table_placeholder,
                draggable: true,
            });
        }
    }

    class ToolbarTopMenu extends Toolbar {
        extraButtons = {};
        constructor(extraButtons) {
            super(ToolbarOrientation.Horizontal);
            this.saveButton = this.addButton({ icon: Save, text: "", title: "Save" });
            this.undoButton = this.addButton({ text: "↩", title: "Undo" });
            this.redoButton = this.addButton({ text: "↪", title: "Redo" });

            if (!!extraButtons) {
                for (var b in extraButtons) {
                    const extraButton = extraButtons[b];
                    this.extraButtons[extraButton.id] = this.addButton({
                        text: !extraButton.icon ? extraButton.text : "",
                        title: extraButton.title,
                        icon: extraButton.icon,
                        onclick: extraButton.onclick,
                        width: !!extraButton.width ? extraButton.width : undefined,
                        id: !!extraButton.id ? extraButton.id : undefined,
                        hidden: !!extraButton.hidden ? extraButton.hidden : undefined,
                        styles: !!extraButton.styles ? extraButton.styles : undefined
                    });
                }
            }
        }
    }

    class ChangeStack {
        constructor() {
            this.stack = [];
            this.index = -1;
            this._lock = false;
        }
        get canUndo() {
            return this.index > -1;
        }
        get canRedo() {
            return this.index + 1 < this.stack.length;
        }
        add(change) {
            if (this._lock)
                return;
            this.index++;
            if (this.index < this.stack.length) {
                this.stack.splice(this.index);
            }
            this.stack.push(change);
        }
        undo() {
            if (!this.canUndo)
                return;
            const change = this.stack[this.index];
            this.index--;
            switch (change.type) {
                case "change-report":
                    this._undoProperties(change.report.properties, change.changes);
                    break;
                case "change-section":
                    this._undoProperties(change.section.properties, change.changes);
                    break;
                case "change-item":
                    this._undoProperties(change.item.properties, change.changes);
                    break;
            }
        }
        redo() {
            if (!this.canRedo)
                return;
            this.index++;
            const change = this.stack[this.index];
            switch (change.type) {
                case "change-report":
                    this._redoProperties(change.report.properties, change.changes);
                    break;
                case "change-section":
                    this._redoProperties(change.section.properties, change.changes);
                    break;
                case "change-item":
                    this._redoProperties(change.item.properties, change.changes);
                    break;
            }
        }
        lock() {
            this._lock = true;
        }
        unlock() {
            this._lock = false;
        }
        _undoProperties(properties, changes) {
            this._changeProperties(properties, changes, true);
        }
        _redoProperties(properties, changes) {
            this._changeProperties(properties, changes, false);
        }
        _changeProperties(properties, changes, undo) {
            this.lock();
            properties.beginUpdate();
            for (const change of changes) {
                properties[change.property] = undo
                    ? change.oldValue
                    : change.newValue;
            }
            properties.endUpdate();
            this.unlock();
        }
    }
    class Designer {
        constructor(options) {
            this.elementContent = document.createElement("div");
            this.menu = new ToolbarTopMenu(options.topMenuButtons);
            this.toolbar = new ToolbarLeftMenu();
            this.sidebar = new Sidebar();
            this.dataSourceTreeList = new DataSourceTreeList();
            this.propertyGrid = new PropertyGrid({ fields: options.dataSource });
            this.changeStack = new ChangeStack();
            this._dataSourceChangeEventEmitter = new EventEmitter();
            const { element } = options;
            this.reportContainer = new ReportContainer({
                designer: this,
                layout: options.layout,
                typeReport: options.typeReport,
                typesSections: options.typesSections
            });
            this.elementsTreeList = new ElementsTreeList({
                reportContainer: this.reportContainer,
            });
            element.classList.add("anka-designer");
            this.elementContent.classList.add("anka-designer__content");
            element.appendChild(this.menu.element);
            element.appendChild(this.elementContent);
            this.elementContent.appendChild(this.toolbar.element);
            this.elementContent.appendChild(this.reportContainer.element);
            this.elementContent.appendChild(this.sidebar.element);
            this.sidebar.addTabs([
                {
                    icon: Database,
                    title: "Data Source",
                    content: this.dataSourceTreeList.element,
                },
                {
                    title: "Elements",
                    content: this.elementsTreeList.element,
                },
            ]);
            this.sidebar.addPanel(TreeStructure, "Properties", this.propertyGrid.element);
            if (options.dataSource)
                this.setDataSource(options.dataSource);
            this.reportContainer.addEventListener("select", (e) => {
                switch (e.type) {
                    case "Report":
                    case "ReportSection":
                    case "ReportItem":
                        if (e.type == "ReportSection") {
                            this.SelectedReportSection = e.element;
                        }
                        let hiddenProperties = ['binding', 'name'];
                        if (e.element.properties.binding == 'CLU|FUNCTION|IMAGE') {
                            hiddenProperties = ['backgroundColor', 'borderColor', 'borderWidth', 'borderStyle', 'binding', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        } else if (e.element.properties.binding == 'CLU|FUNCTION|BARCODE') {
                            hiddenProperties = ['backgroundColor', 'borderColor', 'borderWidth', 'borderStyle', 'binding', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        } else if (e.element.properties.binding == 'CLU|FUNCTION|QRCODE') {
                            hiddenProperties = ['backgroundColor', 'borderColor', 'borderWidth', 'borderStyle', 'binding', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        } else if (e.element.properties.binding == 'CLU|FUNCTION|LINE') {
                            hiddenProperties = ['backgroundColor', 'borderColor', 'borderWidth', 'borderStyle', 'binding', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        } else if (e.element.properties.binding == 'CLU|FUNCTION|VLINE') {
                            hiddenProperties = ['backgroundColor', 'borderColor', 'borderWidth', 'borderStyle', 'binding', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        } else if (e.element.properties.binding == 'CLU|FUNCTION|RECTANGLE') {
                            hiddenProperties = ['binding', 'fontFamily', 'fontSize', 'fontWeight', 'name', 'text', 'textAlign', 'textMode'];
                        }

                        this.propertyGrid.setDataSource(e.element.properties, hiddenProperties);
                        break;
                    default:
                        this.propertyGrid.setDataSource(null);
                        break;
                }
            });
            this.reportContainer.addEventListener("change", (e) => {
                this.changeStack.add(e);
                this.menu.redoButton.disabled = !this.changeStack.canRedo;
                this.menu.undoButton.disabled = !this.changeStack.canUndo;
                switch (e.type) {
                    case "add-section":
                    case "remove-section":
                    case "add-item":
                    case "remove-item":
                        this.elementsTreeList.refresh();
                        break;

                    case "move-section-up":
                    case "move-section-down":
                        this.elementsTreeList.refresh();
                        break;

                    case "update-item":
                        //this.elementsTreeList.refresh();
                        break;
                }
            });
            this.sidebar.searchtext.addEventListener("change", (e) => {
                const datasources = options.dataSource;
                if (!!e) {
                    const matchedDatasources = [];
                    datasources.forEach((datasource) => {
                        const items = datasource.children.filter((item) => item.label.toLowerCase().lastIndexOf(e.toLowerCase()) > -1);
                        if (items.length > 0) {
                            const clonedDatasource = JSON.parse(JSON.stringify(datasource));
                            clonedDatasource.children = items;
                            matchedDatasources.push(clonedDatasource);
                        }
                    });
                    this.setDataSource(matchedDatasources);
                    this.dataSourceTreeList.collapsedByDefault = false;
                } else {
                    this.setDataSource(datasources);
                    this.dataSourceTreeList.collapsedByDefault = true;
                }
            });
            if (options.layout) {
                this.loadLayout(options.layout);
            }
            if (options.onSaveButtonClick) {
                this.menu.saveButton.addEventListener("click", () => {
                    const layout = this.toJSON();
                    options.onSaveButtonClick(layout);
                });
            }
            this.menu.undoButton.addEventListener("click", () => {
                this.changeStack.undo();
                this.menu.undoButton.disabled = !this.changeStack.canUndo;
                this.menu.redoButton.disabled = !this.changeStack.canRedo;
            });
            this.menu.redoButton.addEventListener("click", () => {
                this.changeStack.redo();
                this.menu.undoButton.disabled = !this.changeStack.canUndo;
                this.menu.redoButton.disabled = !this.changeStack.canRedo;
            });

            if (!!this.menu.extraButtons) {
                for (var b in this.menu.extraButtons) {
                    if (!!this.menu.extraButtons[b].onclick) {
                        this.menu.extraButtons[b].addEventListener("click", this.menu.extraButtons[b].onclick);
                    }
                }
            }
        }

        get SelectedReportSection() {
            return this._selectedSection;
        }
        set SelectedReportSection(value) {
            this._selectedSection = value;
        }

        addEventListener(event, callback) {
            switch (event) {
                case "dataSourceChange":
                    const callbackDataSourceChange = callback;
                    this._dataSourceChangeEventEmitter.add(callbackDataSourceChange);
                    break;
                case "change":
                    const callbackOnChange = callback;
                    this.reportContainer.addEventListener("change", callbackOnChange);
                    break;
            }
        }
        setDataSource(dataSource) {
            this.dataSourceTreeList.setDataSource(dataSource);
            this._dataSourceChangeEventEmitter.emit({ dataSource });
        }
        getDataSource() {
            return this.dataSourceTreeList.dataSource.map((x) => x.data);
        }
        loadLayout(layout) {
            this.changeStack.lock();
            this.reportContainer.loadLayout(layout);
            this.elementsTreeList.refresh();
            this.changeStack.unlock();
        }
        toJSON() {
            return this.reportContainer.toJSON();
        }
    }

    class Section {
        constructor(layout, data, defaultStyles) {
            this.layout = layout;
            this.data = data;
            this.defaultStyles = defaultStyles;
            this.element = document.createElement("div");
            this.elementSections = document.createElement("div");
            this.reportItems = [];
            this._init();
        }
        _init() {
            var _a, _b;
            this.element.classList.add("anka-section");
            this.element.style.height = this.layout.height + "px";
            this.element.style.position = "relative";
            const defaultStylesList = [];
            this.defaultStyles.forEach((x) => defaultStylesList.push(new StyleProperties(x)));
            defaultStylesList.push(new StyleProperties(this.layout));
            (_a = this.layout.items) === null || _a === void 0 ? void 0 : _a.forEach((layout) => {
                const item = new ReportItem({ parentStyles: defaultStylesList });
                item.properties.x = layout.x;
                item.properties.y = layout.y;
                item.properties.width = layout.width;
                item.properties.height = layout.height;
                item.properties.color = layout.color;
                item.properties.backgroundColor = layout.backgroundColor;
                item.properties.borderWidth = layout.borderWidth;
                item.properties.borderStyle = layout.borderStyle;
                item.properties.borderColor = layout.borderColor;
                item.properties.fontFamily = layout.fontFamily;
                item.properties.fontSize = layout.fontSize;
                item.properties.fontWeight = layout.fontWeight;
                item.properties.textAlign = layout.textAlign;
                item.properties.textMode = layout.textMode;
                if (layout.binding) {
                    item.properties.text = this.data ? this.data[layout.binding] : "NULL";
                }
                else {
                    item.properties.text = layout.text;
                }
                item.refresh();
                this.element.appendChild(item.element);
                this.reportItems.push(item);
            });
            (_b = this.layout.sections) === null || _b === void 0 ? void 0 : _b.forEach((sectionLayout) => {
                const subDataSource = this.data ? this.data[sectionLayout.binding] : {};
                subDataSource === null || subDataSource === void 0 ? void 0 : subDataSource.forEach((sectionDataSource) => {
                    const section = new Section(sectionLayout, sectionDataSource, [
                        ...this.defaultStyles,
                        this.layout,
                    ]);
                    this.elementSections.appendChild(section.element);
                    this.elementSections.appendChild(section.elementSections);
                });
            });
        }
    }

    class Renderer {
        constructor(options) {
            this.options = options;
            if (!options.data)
                throw "Data is required";
            if (Array.isArray(options.data))
                throw "Data must be an object";
            this.headerSection = new Section(this.options.layout.headerSection, this.options.data, [this.options.layout]);
            this.footerSection = new Section(this.options.layout.footerSection, this.options.data, [this.options.layout]);
            this.options.element.style.width = this.options.layout.width + "px";
            this.options.element.style.position = "relative";
            this.options.element.appendChild(this.headerSection.element);
            const contentProperty = this.options.layout.contentSection.binding;
            this.options.data[contentProperty].forEach((data) => {
                const contentSection = new Section(this.options.layout.contentSection, data, [this.options.layout]);
                this.options.element.appendChild(contentSection.element);
                this.options.element.appendChild(contentSection.elementSections);
            });
            this.options.element.appendChild(this.footerSection.element);
        }
    }

    var version$1 = "0.1.0-beta.15";

    const version = version$1;
    function designer(options) {
        return new Designer(options);
    }
    function render(options) {
        return new Renderer(options);
    }

    function propertyfilepicker(options) {
        return new FilePicker(options)
    }

    exports.designer = designer;
    exports.render = render;
    exports.version = version;
    exports.propertyfilepicker = propertyfilepicker;
    exports.DropdownList = DropdownList;

    return exports;

})({});
